<template>
  <div>
    <div class="container">
    <br>
      <Dice2 />
    </div>
    <br><br>
    <div class="container">
      <div class="centerContainer center">
        <button id="encounterButton"  class="fill ebut button" data-bs-toggle="collapse" data-bs-target="#encounterTable">Encounter</button>
        <button id="formulaButton"  class="fill ebut button" data-bs-toggle="collapse" data-bs-target="#formulaTable">Formula</button>
        <button id="minionButton"   class="fill ebut button" data-bs-toggle="collapse" data-bs-target="#minionsTable">Minions</button>
        <button id="enemyButton"   class="fill ebut button" data-bs-toggle="collapse" data-bs-target="#enemiesTable">Enemies</button>
        <button id="bossButton"   class="fill ebut button" data-bs-toggle="collapse" data-bs-target="#bossesTable">Bosses</button>
        <button id="magicWeaponsButton"   class="fill ebut button" data-bs-toggle="collapse" data-bs-target="#magicWeaponsTable">Weapons</button>
        <button id="creatureTypesButton"   class="fill ebut button" data-bs-toggle="collapse" data-bs-target="#creatureTypesTable">Creature Types</button>
        <button id="questButton"   class="fill ebut button" data-bs-toggle="collapse" data-bs-target="#questTable">Quest</button>
        <button id="foodButton"   class="fill button" data-bs-toggle="collapse" data-bs-target="#foodTable">Food & Drug</button>
      </div>
    </div>
    <div id="accordion">
      <div id="formulaTable" class="container collapse" data-bs-parent="#accordion">
        <table>
          <tbody>
          <tr>
          <td class="fill">
          <p><strong>Enemy Tier</strong></p>
          </td>
          <td class="fill">
          <p><strong>HP</strong></p>
          </td>
          <td class="fill">
          <p><strong>Armor</strong></p>
          </td>
          <td class="fill">
          <p><strong>Movement</strong></p>
          </td>
          <td class="fill">
          <p><strong>Damage</strong></p>
          </td>
          <td class="fill">
          <p><strong>Notes</strong></p>
          </td>
          </tr>
          <tr>
          <td>
          <p><span style="font-weight: 400;">Minion</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">3&ndash;6</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">5&ndash;6</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">4&ndash;6</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">1&ndash;2</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">Weak alone; dangerous in numbers</span></p>
          </td>
          </tr>
          <tr>
          <td>
          <p><span style="font-weight: 400;">Standard</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">7&ndash;12</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">6&ndash;8</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">5&ndash;6</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">1d4&ndash;1d6</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">Balanced threat; ideal for 1v1s</span></p>
          </td>
          </tr>
          <tr>
          <td>
          <p><span style="font-weight: 400;">Elite</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">13&ndash;18</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">7&ndash;9</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">5&ndash;7</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">1d6&ndash;1d8 (+effect)</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">Needs focus from 2 players</span></p>
          </td>
          </tr>
          <tr>
          <td>
          <p><span style="font-weight: 400;">Mini-Boss</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">20&ndash;30</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">8&ndash;10</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">6&ndash;8</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">2d6 or multiattack</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">Special traits &amp; AoEs</span></p>
          </td>
          </tr>
          <tr>
          <td>
          <p><span style="font-weight: 400;">Boss</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">35&ndash;50+</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">9&ndash;10</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">6&ndash;8</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">2d8&ndash;3d6 + effect</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">Multi-phase, with summons or terrain effects</span></p>
          </td>
          </tr>
          </tbody>
        </table>
        <br>
      </div>
    <!-- </div>

    <div id="accordion"> -->
      <div id="minionsTable" class="collapse" data-bs-parent="#accordion">
        <div class="container">
        <table>
        <tbody>
        <tr>
        <td class="fill">
        <p><strong>Minion Name</strong></p>
        </td>
        <td class="fill">
        <p><strong>Type</strong></p>
        </td>
        <td class="fill">
        <p><strong>Move</strong></p>
        </td>
        <td class="fill">
        <p><strong>Attack</strong></p>
        </td>
        <td class="fill">
        <p><strong>DMG</strong></p>
        </td>
        <td class="fill">
        <p><strong>Hot Shot</strong></p>
        </td>
        <td class="fill">
        <p><strong>Armor</strong></p>
        </td>
        <td class="fill">
        <p><strong>HP</strong></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Wisp of Dread</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Chill Touch</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target loses next action</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Shadow Fragment</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ethereal Claw</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Teleports 2 spaces away</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">2</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Lost Soul</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Screeching Rush</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ally gains +1 damage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ghost Spark</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Arc Shock</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Disarms on 6+</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">2</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Cursed Candle</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Flame Wisp</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Burns for 1 dmg next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Jungle Viper</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Lunge Bite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Poison: -1 HP per round</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Screeching Monkey</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Throw Debris</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Lowers target Armor by 1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Horned Beetle</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Horn Jab</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pushes target 1 space</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Carrion Crow</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Peck and Flap</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gains flight for 1 round</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">2</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Lurking Lizard</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ambush Bite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Advantage next round</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Fire Imp</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Spark Toss</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Area burns (1 tile, 1 dmg)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Chittering Fiendling</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Claw Swipe</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gains +1 to next roll</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Crawling Sin</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Acid Touch</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Reduces target&rsquo;s Heal rolls</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bone-Tailed Gnawer</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Spiked Slam</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gains Guard +1 next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ashmaw Crawler</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Burning Bite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ignores 1 point of Armor</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bandit Lookout</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Shortbow</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Warns allies (1 Move bonus)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Knifefoot Thief</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Quick Stab</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">#ERROR!</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Cutpurse Gutter</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gut Jab</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Steals 1 item on 10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Crossbow Ruffian</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Loaded Bolt</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pins target in place</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Highway Sneak</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Sucker Punch</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target loses Guard 1 round</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Sporeling</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pollen Burst</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Dazes (disadvantage 1 turn)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bramble Creeper</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Vine Lash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Restrains 1 round on 6+</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Cactus Sprinter</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Needle Barrage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Hits 2 targets in range</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Rootling</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Tendril Whip</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pulls target 1 space</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Acidbud</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Spit Shot</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Melts 1 Armor on 10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bone Rat</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Swarm Nibble</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">#ERROR!</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">2</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Skeleton Sentry</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Rusted Sword</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Immune to fear effects</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Tombshade</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Wail</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target skips next Move</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bone Shambler</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Club Slam</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Lowers Might of target 1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Corpse Crawler</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Leech Bite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Heals 1 on hit</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Mist Fragment</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Blinding Drift</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target rolls at -1 next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Vine Snake</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Venom Fang</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Poison 1 round</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Smoke Imp</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Cinder Puff</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Vanishes after attack</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">2</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Grave Caller</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Bone Rattle</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Summons 1 Bone Rat</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Fungus Pod</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Spore Bloom</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Hits adjacent enemies</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Thornsnipe</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Vine Bolt (Ranged 4)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Armor pierce 1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Black-Eyed Crow</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Dive Bomb</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Hits then flees</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Blade Monk Acolyte</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Swift Strike</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Adds 1 to Initiative</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Flame Flicker</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Cinder Claw</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Burns target for 1 turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Grave Drudge</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Slam</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Slows target 1 space</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Barkbiter</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gnaw</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Lowers Armor by 1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bandit Crawler</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Shiv Jab</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gains Dodge 1 turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Scorch Pod</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Heat Pulse</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ignites tile for 1 round</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Hollow Stare</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gaze</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target skips Block chance</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">2</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Thorned Stalker</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Lash Strike</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Bleeds 1 round</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ember Spiderling</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Flamebite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target rolls at Disadvantage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Pit Vulture</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Aerial Peck</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gains +1 next attack roll</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Daggerfiend</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Slash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Inflict Bleed (1 dmg/turn)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Howling Shade</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Wail</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target is Deafened (-1 Action)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Jungle Snapjaw</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Bite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pulls target 2 spaces</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Grove Strangler</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Vine Lash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Immobilize target</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Rotten Pilgrim</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Club</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target gets -1 Armor next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Cult Blade</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Dual Slash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">2d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Can strike again if both hit</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Spine Crawler</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Leap Pounce</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target knocked Prone</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Blood Gnasher</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gore</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Heals self 2 HP</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Hollow Drifter</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Chill Touch</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target cannot Heal next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bone Clubber</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Heavy Swing</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Stuns target if Hot Shot</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Thorn Spitter</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ranged Spike</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pierces 1 Armor</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Muckling Beast</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Sludge Bash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Slows target</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Abyssal Flamekin</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Firebolt</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Burns for 1 extra turn (1 dmg/turn)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Shrouded Killer</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Backstab</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Auto-hit if target is unaware</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Mist Lurker</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Fade Strike</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Becomes Invisible for 1 turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Moss Crawler</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Lash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Clings: -2 Move</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Vulture Dog</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Talon Slash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Moves again after hit</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Blackflame Imp</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Spark Burst</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Chain Hit to nearby enemy</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bone Warden</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Bone Slam</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Blocks 1 incoming attack</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Cult Firestarter</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Torch Swing</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Lights small fire in area</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ghost Mumbler</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gibbering</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Confuses target for 1 Action</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Toxic Ivy</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Lash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Poisons for 2 turns (1 dmg/turn)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Glade Bruiser</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gore</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pushes target 2 spaces</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Malicious Grinner</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Cackle Bolt</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target loses 1 Action on fail</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Withered Peasant</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Rake Swing</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Sloppy, but rolls 2 dice</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Blade Initiate</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Precise Slash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">#ERROR!</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Whispering Phantom</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Possess</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Controls enemy movement 1 turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bramble Creeper</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Entangle</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Rooted, no Move next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Raptorling</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Claw Swipe</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">#ERROR!</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ember Devil</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Flame Spit</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Burns for 1 dmg/turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Skelly Archer</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Bow Shot (6 range)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">#ERROR!</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Torch Zealot</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Wild Swing</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">On 10, lights enemy on fire</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Pale Screamer</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Shatter Cry</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Area attack (targets 2)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Creeping Fungoid</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Spore Puff</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Fog: all ranged -2 next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Tuskback Boar</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Charge</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Knockback 3 spaces</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Hatebound Imp</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Hate Spike</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Retaliates for 2 dmg if KO&rsquo;d</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Grave Watcher</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Heavy Swing</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Advantage on first Block</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Fanatic Duelist</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Lunge</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Can reroll one die per turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Moonshade Spirit</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Curse Touch</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target rolls with Disadvantage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bursting Podling</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Self-Destruct</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Explodes, dies</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Razorbeak</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Dive Peck</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">-1 Armor for 1 turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Slimebound Demon</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Slam</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Splits into 2 d4 minions on death</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bone-Tied Lurker</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Hook Chain</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pulls target 3 spaces</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Knife Cultist</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Flurry of Cuts</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4+2</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Applies Bleed (1 dmg/turn)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Lurking Shade</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Phantasmal Claws</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">May vanish instead of moving</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Sapling Leaper</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Slam</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">On 10, stuns 1 turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Marsh Hound</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Snap</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Advantage if ally nearby</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Blight Imp</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Blight Touch</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target gets -1 Healing received</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bone Crawler</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Claw Slash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Grab target (lose 1 Move)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Swamp Rat</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Bite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Infect (1 damage next turn)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Thorn Viper</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Fang Strike</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Poison (2 turns)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Dune Wight</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Dust Swipe</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Blind (disadvantage 1 turn)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Scorchling</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Flame Tongue</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Burn (1 damage next turn)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Creeping Ivy</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Vine Whip</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Slow (&ndash;2 Move next turn)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Grave Whisper</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Psychic Scream</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Panic (cannot block next turn)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bone Imp</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Bone Dagger</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Bleed (1 per turn, 2 turns)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Forest Bandit</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Short Sword</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Steal item (roll 10)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ghoul Snapper</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Maw Bite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Paralyze (1 turn)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Pestling</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gnaw</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Multiply (summon 1 Pestling)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">2</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Mind Leech</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Mental Jab</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Drain 1 Action</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Thistleback</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Quill Burst</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Auto-hit all adj. foes</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Cave Raider</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Club</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Push 1 space</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Murk Demon</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Shadow Claws</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Hide (ignore 1 attack)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Chill Specter</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Frost Touch</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Freeze (lose Move)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Deathcap</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Spore Burst</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Disorient (random target)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Wolf Pup</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pounce</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pack Hunt (+1 next attack)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Shade Slasher</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Shadow Blade</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Slip away (free move)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Plague Rat</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Infectious Bite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Spread (enemy must roll 6+)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ember Bat</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Fire Screech</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Hit all adj. foes</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">2</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Skeletal Hound</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gnash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pursue (free Move to target)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Jungle Strangler</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Tendril Grab</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Immobilize 1 turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Corpse Juggler</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Bone Toss</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ranged (Range 4)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Cult Acolyte</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Dagger Jab</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Buff ally +1 DMG next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Mossback Boar</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Tusk Slam</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Stagger (&ndash;1 Action)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Screecher</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Sonic Shriek</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Disrupt (no reaction)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Hexbound Spawn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Curse Touch</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Curse (&ndash;1 to rolls 1 turn)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Hollow Skull</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Head Bash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Break item on 10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Root Snapper</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Latch Bite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Trap (must use Action to break)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Tree Howler</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Swipe</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Rally (call another Howler)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Cave Stalker</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Spear Jab</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Hit from 2 spaces</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Mind Fragment</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Confuse</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target switches team 1 turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Sludge Fiend</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Muck Lash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Slow (&ndash;2 Move)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Mournshade</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Haunt</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ignore Block on 10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ash Crawler</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Molten Swipe</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Burn (1/turn 2 turns)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Vine Raptor</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Claw Swipe</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Grapple (must break free)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Crag Imp</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Rock Chuck</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ranged (Range 5)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Snow Beast Cub</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pounce</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Chill (&ndash;1 Action)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bandit Slinger</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Sling Shot</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Disarm (drop item on 10)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Whispering Skull</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Shriek</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Confuse (random movement)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Cursed Flame</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Fire Lash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Chain 1 space</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Wither Bloom</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pollen Burst</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Heal self 1 HP on 10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Blighted Hound</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Fetid Bite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Poison (2 turns)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Hunter&rsquo;s Apprentice</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Training Blade</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">#ERROR!</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Crystal Wisp</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Spark Touch</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Shock (&ndash;1 Armor)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Jungle Myconid</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gas Spore</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Confuse (random action)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Fireling Rat</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Spark Bite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">1d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ignite (1 damage)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        </tr>
        </tbody>
        </table>
      </div>
      <br>
    </div>
    <!-- </div>

    <div id="accordion"> -->
      <div id="enemiesTable" class="collapse" data-bs-parent="#accordion">
        <div class="container">
        <table>
        <tbody>
        <tr>
        <td class="fill">
        <p><strong>Enemy Name</strong></p>
        </td>
        <td class="fill">
        <p><strong>Type</strong></p>
        </td>
        <td class="fill">
        <p><strong>Move</strong></p>
        </td>
        <td class="fill">
        <p><strong>Attack</strong></p>
        </td>
        <td class="fill">
        <p><strong>DMG</strong></p>
        </td>
        <td class="fill">
        <p><strong>Hot Shot</strong></p>
        </td>
        <td class="fill">
        <p><strong>Armor</strong></p>
        </td>
        <td class="fill">
        <p><strong>HP</strong></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Phantom Wailer</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Echo Wail</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target -1 to next Action Roll</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Clockwork Mauler</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Grapple Claws</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s Armor -1 until end of next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">12</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Dire Wolf</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Fang Lunge</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Makes a second bite for d4 damage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">10</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Forest Stag</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Antler Slam</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s next Action Roll -1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Imp Flayer</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Mind Spike</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target cannot heal until end of next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Hell Brute</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Crushing Blow</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target takes +2 HP damage and stunned until next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">14</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bandit Sharpshooter</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ranged Shot</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ignores target&rsquo;s Armor on this attack</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Mercenary</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Tactical Strike</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Next Action Roll gains +1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">10</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Acid Sludge</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Corrosive Splash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s Armor -1 until healed</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Thorn Creeper</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Whip Vines</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s next Attack Roll -1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">10</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bone Walker</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Rattle Slash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target -1 to Block attempts until next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">11</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ghoul Maw</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Flesh Rip</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Heals 2 HP if this drops target to 0 HP</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Mossback Lurker</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Whipping Vines</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s next Action Roll -1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Hexbound Cultist</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Dark Bolt</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Heals 2 HP if this attack hits</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Gnashing Hound</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Savage Lunge</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target cannot move next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Skull Archer</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Rotshot Arrow</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s Armor -1 until the start of its next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Rust Walker</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Crush Grip</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Breaks 1 non-magical item the target is holding</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Spined Imp</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Tail Jab</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target takes 1 HP damage at the start of its next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Stone Gnasher</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Chomp</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">If target is hit, their next Block is at -1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Vile Bloom</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Spore Burst</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">All targets in 2 spaces take 1 HP</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Haunt Echo</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Screech</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Disables one Action of target&rsquo;s choice next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Revenant Brute</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Bone Slam</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pushes target 2 spaces away</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">10</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Tarling</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Sludge Lash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s next Action Roll -1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Blood Cultist</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ritual Blade</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Heals 2 HP if this hits</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Hellwing</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Wing Slash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target takes 1 damage at the start of their next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Gnarlhound</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Vicious Bite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target cannot move on their next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Steel Strider</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Arc Claws</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target cannot use an At-Will ability on their next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Dread Walker</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Cracked Mace</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s Armor -1 until the end of their next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Fume Sprite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Fire Burst</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">All enemies in 1 space take 1 damage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Thornback</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Spine Toss</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s next Block Roll is made with -1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Echo Husk</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Crippling Swipe</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target loses 1 Action on their next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Plated Juggernaut</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Slam Fist</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target is pushed 1 space and loses 1 Armor until next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">10</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bog Creeper</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Grasping Roots</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s Movement is reduced by 2 next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ashdrinker Acolyte</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Charred Knife</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Deals +1 damage if the target is below half HP</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Scorch Beetle</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Lava Spit</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Deals 1 damage to all targets adjacent to the primary target</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Snarlbeak Raptor</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Talon Strike</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target must re-roll their next successful Action Roll</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Glint Drone</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pulse Beam</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target cannot Heal until end of their next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Rattling Shade</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ghost Claws</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s next Attack deals -1 damage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Muck Lurker</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Slime Slam</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target loses 1 Armor until the end of their next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Iron Fang</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Maul Bite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">If target Blocks, they take 1 damage anyway</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Vein Collector</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Blood Pierce</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Heals 1 HP per damage dealt</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Phantom Bounder</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Echoing Slam</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target loses 1 Action next turn if this hits</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Scavenger Rat</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Bite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gain +2 Move on its next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Hollow Walker</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Rusty Slash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Reduce target's next Action Roll by 1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Flame Grub</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Fire Spit (Range 4)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Splash 1 Fire DMG to adjacent targets</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bone Crawler</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Claw Swipe</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Cling to target: target loses 1 Move next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Imp Trickster</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Wand Jab (Range 6)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Swap places with target</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Cave Snapper</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Bite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">#ERROR!</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">10</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Fetid Bulb</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pollen Burst (R4)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">-1 to all target Action Rolls (until hit)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ghastling</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Phantasmal Chill</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target can't Block until end of its next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Blight Leech</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Drain Touch</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Heal self d4 HP</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Grave Snatcher</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Grave Shovel</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pulls target 2 spaces closer</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Hooded Zealot</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Dagger Thrust</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Next attack deals +1 damage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Cult Priest</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Dark Bolt (Range 6)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Heal nearest ally d4 HP</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Possessed Acolyte</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Scratch and Gnash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s next Armor boost is ignored</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bleeding Idol</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Psychic Pulse (R3)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">All targets -1 to their next Action Roll</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">10</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Shadow Knife</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ghost Blade</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Teleports 2 spaces before or after attack</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Cult Priest</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Barbed Swipe</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target gets -1 to their next Action Roll</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Antler Beast</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gore</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pushes target 2 spaces</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Tree Grub</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Acid Spit (Range 4)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s Armor -1 until they are hit</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Shadelurk</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Sneaky Jab</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Moves 2 spaces for free after hit</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Briarhowler</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Vicious Bite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">All allies gain +1 Move next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Sneakblade</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 + 1 (Agility Melee)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Move 2 spaces without provoking a Block</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Crossbow Jack</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 + 2 (Agility Ranged)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Attack again on a different target in range</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Trapsetter</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 1 (Wisdom, Trap Bolt)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">The next enemy to move takes d4 damage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bandit Brute</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8 + 1 (Might)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Targets within 2 take 1 splash damage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Scoutmark</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 + 2 (Agility Bow)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">The target&rsquo;s next Action Roll is -1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Silent Fang</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 + 3 (Knife Throw)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">-1 Armor to target until hit</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Cutpurse</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 + 2 (Agility Dagger)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Steals 1 Action from the target next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Netcaster</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 + 1 (Ranged Net)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">0 (Immobilize)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target cannot move next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Path Snare</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 1 (Wisdom Lure)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target is pulled 2 spaces toward attacker</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Tracker Varn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 + 2 (Agility Bow)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Reroll one missed Attack this turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Snarl Hound</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 1 (Bite)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target takes -1 to next Action Roll</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Mossback Boar</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8 + 0 (Charge)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Knockback 1 space</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Hookclaw Hawk</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8 (Fly)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 + 2 (Dive Talon)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Blindside: +1 damage if target didn't move</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Whipfang Cat</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 + 2 (Pounce)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Move 2 after hit</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bog Lizard</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 1 (Lash Tongue)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Reduces target movement by 2 next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Razor Elk</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 1 (Antler Gore)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">If target moved this turn, deal +1 damage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Marsh Stalker</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 + 2 (Lurking Bite)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Advantage on next Attack Roll</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Cave Hyena</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 1 (Pack Bite)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">If an ally is adjacent, deal +1 damage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Venom Viper</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 + 2 (Fang Strike)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">-1 Armor to target until they are Healed</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Snare Spider</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 0 (Web Shot)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target cannot move next turn (on 6+)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Imp Slinger</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 + 2 (Flame Bolt)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target loses 1 Action on next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Brimstone Gnasher</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 1 (Magma Bite)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target gets -1 Armor next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Void Howler</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8 + 0 (Sonic Wail)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Allies within 2 spaces gain +1 to next roll</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Flamebound Knight</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 2 (Burning Slash)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Deals 2 splash damage to nearby enemies</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">10</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ash Revenant</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 1 (Cinder Grasp)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target takes 1 fire damage at start of next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Hellhook Fiend</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8 + 1 (Barbed Chains)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pulls target 2 spaces</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Tormentor</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 2 (Psychic Lash)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">-1 to all target&rsquo;s rolls next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Rotling</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 + 1 (Claw Swipe)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Regains 1 HP if target is at 0 HP</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bone Archer</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 + 2 (Piercing Arrow)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ignores 1 Armor</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Gravewalker</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 1 (Rust Sword)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">-1 to target&rsquo;s next Damage Roll</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Wailing Shade</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6 (Float)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 0 (Shriek Pulse)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target gets -1 to all Action Rolls next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ghoul Packmaster</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 2 (Flesh Tear)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">All ghouls get +1 move next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Crypt Knight</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8 + 1 (Grave Blade)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Reduces healing received by 1 until next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">10</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Lich Ember</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 2 (Darkfire Blast)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Revives 1 nearby Undead with 1 HP</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Vine Snapper</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 1 (Whip Vines)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pulls target 1 space and lowers their next roll by 1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Spore Bulb</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 0 (Spore Burst)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target has -1 to next Attack Roll</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Creep Cabbage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 + 2 (Bite &amp; Wiggle)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gains 1 HP if Hot Shot lands</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Sap Slime</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 1 (Sticky Glob)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target cannot move on its next Action</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Glowmold Cluster</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">0 (Immobile)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 1 (Radiant Spores)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Allies gain +1 to Action Rolls next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Acid Sludge</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 2 (Corrosive Slam)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s Armor is reduced by -1 for the round</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Tendril Bramble</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 + 2 (Multi-Lash)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target loses 1 Action on next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bloom Horror</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8 + 0 (Petal Flurry)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">All enemies within 2 spaces take 1 damage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Jungle Viper</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Venom Fang</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target takes d4 at the start of their next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">10</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bog Snapper</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Bite &amp; Hold</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s movement is halved until end of their next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">12</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Razorbeak Raptor</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Screeching Dive</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target gets -1 to their next Action Roll</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Forest Stag</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Antler Gore</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Push the target 2 spaces away</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">13</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Thornhide Boar</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Tusk Slam</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 + 1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">The boar gains +1 Armor until its next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">14</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Swamp Scuttler</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pincer Jab</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">If target is flanked, add +1 damage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">11</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Rockhide Lizard</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Tail Whip</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target must reroll their next successful Attack Roll</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">13</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Duskhound</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pack Maul</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">If another ally is adjacent to the same target, +2 damage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">10</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Feral Hyena</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Rabid Bite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gain +1 Move next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bloodfang Jackal</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Howling Lunge</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target is Shaken (can&rsquo;t use Hot Shot next turn)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">11</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bandit Raider</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Crude Slash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Steals 1 Weapon Slot item if target is knocked out</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">12</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Cultist Firehand</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Scorching Palm</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target takes 1 damage at end of next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">10</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ghoul Strangler</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Neckclutch</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target gets -1 to next Block Roll</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">13</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bone Crawler</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Serrated Crawl</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">If target is prone, deal +2 damage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">11</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Lesser Flame Demon</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Flame Claw</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target gets -1 Armor until end of next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">12</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Horned Imp</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Tail Pierce</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Move 2 spaces after the attack</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">10</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Wailing Shade</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Soul Shriek</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target's next Action Roll uses 2d10, take the lower</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Glimmer Wraith</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Lightdrain</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target cannot Heal next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">10</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Spore Slime</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Spit Glob</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">-1 to Initiative next round</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">11</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Vine Creeper</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Whip Tendril</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pulls target 2 spaces closer</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">12</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Thorn Slasher</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Piercing Bramble</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">If target is at full HP, deal +1 damage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">11</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Night Owl Scout</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Silent Shot</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target has -1 to next Action Roll</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">10</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Carrion Raven</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pecking Talons</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gains +1 Armor until its next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Mossback Turtleling</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Shell Slam</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">#ERROR!</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">14</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Maggot Host</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Rotburst</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target cannot regain HP until end of next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">12</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ashen Brute</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Molten Fist</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6+1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Deal d4 to self</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">13</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Crypt Revenant</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Chill Slash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target gets -1 to next Action Roll</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">13</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Frost Wight</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Frozen Grasp</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target is Slowed: -2 Move next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">12</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Tomb Shade</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Whispers of Ice</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s next Action Roll uses 2d10, take lower</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">10</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Howling Ghost</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Screaming Gale</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Push target 2 spaces away</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Snow-Cursed Knight</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Icy Greatsword</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s Armor is reduced by -1 until hit</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">15</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Winter Wolf</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Crushing Jaws</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Move 2 spaces after hit</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">12</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Icebound Archer</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Frost-Tipped Arrow</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">If hit, target&rsquo;s Move is reduced by 2 until next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">11</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Frozen Cultist</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Glacier Bolt</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target loses 1 Action next turn (on 10)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">10</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Tomb Scarab Swarm</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Icy Bites</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">2d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target cannot Heal next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">13</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Snowmelt Slime</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Frost Bomb</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 (AoE)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">All in 2-space burst get -1 to next Action Roll</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">12</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Shard Golem</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Crystal Slam</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">All targets within 1 space take d4 damage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">16</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ice Elemental</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Frozen Barrage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">2d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target must succeed Action Roll or skip next Movement phase</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">14</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Frost Flayer</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Skewer of Ice</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pulls target 2 spaces closer</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">12</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Cursed Sentinel</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Glacial M2</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">On Hot Shot, disables one of target's Weapon Slots next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">14</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bone Wyrm Pup</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Tail Spike</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Next Block Roll against it is made with -2</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">13</span></p>
        </td>
        </tr>
        </tbody>
        </table>
      </div>
    </div>
    <!-- </div>

    <div id="accordion"> -->
      <div id="bossesTable" class="collapse" data-bs-parent="#accordion">
        <div class="container">
        <table>
        <tbody>
        <tr>
        <td class="fill">
        <p><strong>Boss Name</strong></p>
        </td>
        <td class="fill">
        <p><strong>Type</strong></p>
        </td>
        <td class="fill">
        <p><strong>Move</strong></p>
        </td>
        <td class="fill">
        <p><strong>Attack</strong></p>
        </td>
        <td class="fill">
        <p><strong>Damage</strong></p>
        </td>
        <td class="fill">
        <p><strong>Hot Shot</strong></p>
        </td>
        <td class="fill">
        <p><strong>Armor</strong></p>
        </td>
        <td class="fill">
        <p><strong>HP</strong></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Wailing Specter</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Piercing Wail</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target is stunned until end of next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">18</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Iron Juggernaut</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Crushing Grapple</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s Armor reduced by 2 until end of next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">20</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Dire Alpha Wolf</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Savage Bite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Attack ignores 1 Armor on this strike</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">16</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Great Stag Lord</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Antler Charge</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s next 2 Action Rolls are at -1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">15</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Demonic Enforcer</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Fiery Strike</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target cannot heal for 2 turns</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">17</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">HellM-2 Brute</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Heavy Slam</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target is stunned and takes +2 damage for 1 turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">20</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Sharpshooter Captain</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Piercing Shot</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Attack ignores Armor and deals +1 damage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">15</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Veteran Mercenary</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Precision Strike</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gains +2 to next Action Roll</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">17</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Corrosive Ooze</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Acidic Blast</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s Armor reduced by 2 until healed</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">15</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Thorn Bramble King</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Whip Lash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s next 2 Attack Rolls at -1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">16</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bone Lord</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Crushing Slash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s Block attempts at -2 until next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">18</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ghoul Pack Leader</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Devouring Bite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Heals 4 HP if drops target to 0 HP</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">16</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Gravelock the Bone Warden</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Bone Spear Throw (6)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s next Action Roll is at -2</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">16</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Thornmaw, Grove Tyrant</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Vine Slam (Range 2, 2 targets)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Reduce Movement of hit targets by 2 until their next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">18</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ashcaller Vexx</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Fire Whip (4)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">All enemies within 2 spaces of the target take 1 damage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">14</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Fangmother Eztari</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pounce (Move + Attack)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Makes a second immediate Attack</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">15</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Phantom of Shrieking Vale</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Mind Spike (6)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target skips their next Action</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">13</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Sir Rowlan the Hollow</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Sword Barrage (2 attacks)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">2 &times; d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Add d6 to one hit&rsquo;s damage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">17</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Shade Reaver</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Venom Fang</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 2</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ignores 1 Block or Armor next hit</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">38</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ashmaw the Burning</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Flame Eruption</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 2</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">All enemies within 2 spaces take d4 fire</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">42</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bonehowler</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Piercing Shriek</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Targets must reroll their next Action Roll</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">40</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Thornfather</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Needle Swarm</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 + 2</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Roots 1 enemy (Move 0 next turn)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">38</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Maskbearer</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Veil Slash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Reduces target&rsquo;s Armor by 1 until end of next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">36</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Cult Matron Velra</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Blood Chant</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 2</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">One ally regains 1d4 HP</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">34</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Frostwight Revenant</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Cold Bite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s next Action Roll is made at -1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">36</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Chitterking</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Skitterflurry</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 x 2</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Moves an extra 3 spaces after the attack</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">34</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Wyrdwood Sentinel</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Branch Smash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8 + 1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pushes target 2 spaces and roots them</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">38</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Void-Eyed Seer</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Mindpierce</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 2</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target cannot use Reaction abilities next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">35</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Harrowhound Alpha</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Rending Charge</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Makes a second attack on another adjacent target</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">36</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">The Hollow Mask</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Soul Tear</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Steals 1 HP and gives it to another enemy</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">39</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Goremaw Tyrant</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Jawcrush</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target cannot Heal next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">45</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Duskblade Assassin</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Shadow Step</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Teleports behind the target and lowers their Armor</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">34</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Sunken Priest of Mire</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Drown Curse</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 + 2</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target takes an additional d4 next time they are hit</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">37</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Rotborn Colossus</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Decay Slam</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">All enemies in range take -1 to Armor this round</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">50</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Blightmother</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Spore Burst</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A sporeling minion spawns at 1 HP</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">35</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">The Red Judge</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Executioner&rsquo;s Edict</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Choose: Stun target 1 turn or reduce Armor -1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">42</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Shrouded Flamecaller</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ember Surge</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Next attack this round is automatically successful</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">38</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Glutton of the Black Gate</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Consume Essence</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 2</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Heals self for half the damage dealt</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">40</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ghostwind Shade</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ethereal Cut</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 + 1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target can&rsquo;t Block until their next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">32</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Carrion Fang</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Infecting Lunge</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target takes d4 poison next turn (ignores Armor)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">22</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Shriekbell Acolyte</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Disrupting Tone</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 + 2</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s next successful attack deals -1 damage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">20</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Mossback Brute</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Rotmaul</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Slows target (&ndash;2 movement next turn)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">24</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Wailing Widow</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Grasp from Beyond</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target cannot Heal or be Healed until their next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">23</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Hexflame Cultist</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Cinder Curse</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target rolls 2d10 on next Action Roll and takes lower</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">21</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Hollow Fang</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gnashing Sprint</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 x 2</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Makes a free Move of 3 after attacking</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">22</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Vinecoil Horror</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Strangling Lash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target loses 1 Action next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">23</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bleeding Huntsman</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pierce and Pursue</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">If target has &lt; half HP, add +2 damage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">21</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ashblight Emberling</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Scorch Jet</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 + 1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">If target is hit, their next damage roll deals -2</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">20</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Soulbit Apparition</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Haunting Touch</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target rolls next Action Roll with -1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">19</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Vile Jungle Serpent</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Constrict &amp; Strike</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target is grabbed: cannot move until it spends 1 Action</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">26</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ancient Snapjaw</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Shell Crush</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s Armor is reduced by -1 until end of next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">28</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Dreadmaw Crocodile</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Deathroll Latch</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6 + 2</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target takes d4 damage at start of its next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">30</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Dire Jungle Panther</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Shadow Pounce</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d4 + 1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Move 3 spaces before or after the attack (no Action required)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">24</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Four-Armed Kongrak</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Crushing Frenzy</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">2d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Makes an immediate bonus attack against another adjacent foe</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">32</span></p>
        </td>
        </tr>
        <td>
        <p><span style="font-weight: 400;">Vokar the Flame Maw</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Inferno Crush</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Burns 2 HP next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">30</span></p>
        </td>
        <!-- </tr> -->
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ashen Widow</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Webbed Embrace</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Immobilize target</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">28</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Briarthorn King</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Vine Slam</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Armor -1 for 2 turns</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">32</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">High Seer Velmari</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Psychic Lance</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Disadvantage on next Action</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">26</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Gravemaw Colossus</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Bonequake</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d12</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Knockback 2 spaces</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">34</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Wyrm of the Lost Vale</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Tail Rake</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Hit all adjacent players</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">30</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Echo of Sorrow</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Wail of Despair</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">All players lose 1 Action</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">28</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Dreadforge Juggernaut</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Crushing Armature</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Knock Prone</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">35</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Rootheart Ent</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Entangle Grip</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Roots target, range 0 next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">33</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">The Bladed Prophet</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Execution Strike</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Bonus strike on a second player</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">27</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Skelkrak the Many-Armed</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Bone Flurry</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">2d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Hit 2 targets</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">29</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Crimson Prowler</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Lacerating Leap</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Bleed for d4 next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">26</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Mirror Fiend</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Reflected Misery</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Reflect last attack taken</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">28</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Night Maw</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Chomp of the Abyss</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d12</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ignore Armor</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">30</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Hollow Seraphim</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Echo Pulse</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target loses Hot Shot next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">27</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Fungal Sovereign</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Spore Surge</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Confuse (disadvantage on next roll)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">29</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Blackfang Ravager</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Savage Rend</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Follow up attack if target falls</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">28</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ghoulblade Knight</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Blight Slash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Heal self for half damage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">30</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Arcbinder Xel</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Lightning Hex</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Stun (lose 1 Action)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">25</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Cindering Monarch</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Blazing Reign</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Fire spreads, hits all in 2-radius</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">29</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Wailing Thorn Hag</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Lash of Woe</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Poison for d4 on next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">27</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ironspike Champion</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Impale</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target loses movement next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">28</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Specter of the Bell</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Droning Toll</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Fear: -1 to next 2 rolls</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">26</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Croc God N'Qualla</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Snapjaw Terror</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d12</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Grab and pull into water</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">32</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Doomchant Siren</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Mind Song</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">All targets roll at disadvantage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">27</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Blightfather Groth</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Fungal Slam</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Cloud forms, obscure zone</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">30</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Daggercloak Liege</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Triple Jab</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Extra hit on nearest player</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">26</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Gravecaller Ixil</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Soul Drain</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Summon skeleton if target KO'd</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">29</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Crimson Wolffather</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ravage Howl</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Allies gain 1 extra Action</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">28</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ashroot Devourer</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Mulch Crush</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Armor -2 this turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">31</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Wisp Tyrant</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Flicker Burst</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Teleport behind target</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">25</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Stormbane Herald</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Sword of Winds</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Push 3 spaces back</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">26</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Oozing Horror</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Acidic Pummel</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Armor reduced permanently</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">29</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Flameclaw Alpha</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ignite Rake</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Burn for 2 rounds</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">28</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Thorncradle Mother</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Nest Smash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Summons 2 vine minions</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">30</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Lord of Chains</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Hook Drag</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target pulled 3 spaces</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">29</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Lurking Eye</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gaze of Madness</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Roll twice, use lower for next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">27</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Fangs of the Depths</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Drown Chomp</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Drenches gear, lose next weapon swap</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">29</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Soul-Forge Revenant</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Infernal Strike</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d12</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Re-roll next failed attack</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">30</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Thorn-Horn Ravager</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gore Rush</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Stuns target if into wall</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">27</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Redmist Executioner</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Guillotine Arc</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Bonus action next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">28</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Queen of the Hollows</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Black Pulse</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">All lose 1 HP if within 4 spaces</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">25</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Maw of the Void</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Devour Reality</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d12</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Blocks 1 healing received next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">30</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Deathbloom Hydra</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Triple Whip</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3d4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Can strike 3 players</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">32</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Spinecoat Basilisk</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Petrify Glare</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target skips next movement</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">28</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Gravehowl Alpha</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pack Rend</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Summons 2 lesser wolves</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">27</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">High Templar Karesh</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Divine Wrath</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d12</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Armor +1 to allies for 1 turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">29</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Lichen Lord</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">3</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Cling and Wither</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Heals for d4 next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">28</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Spectral Baron</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Haunting Slash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Advantage on next attack</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">26</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Boneclaw Matron</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Raking Bones</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Stuns target</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">26</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ashvine Tyrant</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Vine Slam</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pulls target 2 spaces</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">24</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Hollow Prophet</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Psychic Lance</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Confuses target (random action)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">23</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Broodmother Zasha</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Claw Rend</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Spawns 1d2 Spiderlings</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">28</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Wightbound King</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Spectral Cut</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Leech 2 HP</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">25</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Blightroot Maw</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Lashing Tendrils</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Disarms weapon for 1 turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">27</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Embermaw Centipede</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Molten Bite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Burns for 1d4 rounds</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">24</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Shrieking Widow</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Razor Screech</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Stuns all within 2 spaces</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">22</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Malgrith, Flesh Harvester</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gore Cleave</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Reduces target Armor by 1</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">30</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Cragbone Serpent</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Bone Crush</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Targets lose next movement</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">25</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Gravemind Slitherer</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Neurotoxic Whip</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">-1 to next Action Roll</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">24</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Frost-Helm Revenant</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Chill Grasp</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target&rsquo;s Move -2 next round</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">26</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Thirsting Baron</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Piercing Rapier</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gains Action on Hot Shot</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">23</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Fireglass Djinn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Blazing Surge</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Explodes in 2-space radius</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">25</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Phantom Duelist</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Spectral Slash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gains +1 Armor until next turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">22</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Mycelial Terror</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Spore Cloud</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Targets make roll at Disadvantage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">24</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Vulturebone Scribe</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Curse Ink</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Curses target (-1 to all rolls)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">23</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Gutdrinker Howler</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Savage Maul</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gains HP equal to damage dealt</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">26</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Thornsoul Sovereign</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Thorn Bloom</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Spawns thorn walls (hazard)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">27</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Hexblade Shade</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Darkfang Cut</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gains Invisibility for 1 turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">22</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Omenbeast</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Crushing Stampede</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Knocks all in 1-line prone</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">28</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Sorrowmaw Drake</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Acid Jet</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Reduces Armor by 2 for 2 turns</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">26</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Crimson Thorn Prophet</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Briar Brand</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target bleeds (1/turn)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">25</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Hollow-Eyed Oracle</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Blinding Revelation</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Targets lose next Action</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">23</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Grave-Touched Knight</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Tomb Blade</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Cannot be healed next round</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">27</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Carrion Wyrm</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Festering Bite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Spreads disease (Disadvantage)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">25</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Embercaller Shaman</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Fire Totem</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Summons fire zone</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">23</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Abyssal Chainbeast</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Hook Pull</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pulls target and stuns</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">9</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">29</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Whisperthorn Dryad</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Entangling Grasp</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Immobilizes for 1 turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">24</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Fleshmelt Revenant</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Acid Claw</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Melts 1 Armor permanently</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">26</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Blazefang Lynx</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Flame Dash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">May act again on Hot Shot</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">23</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Corpsebinder Arcanist</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Bone Lash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target skips next movement</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">24</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Murkfang Alpha</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pack Slash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Nearby minions gain extra turn</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">25</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Thorncoil Hydra</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Twin Bite</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Attacks twice on Hot Shot</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">28</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Deathgazer Fiend</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Mindburn Ray</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target can&rsquo;t use Spicy Bonks</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">22</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ebon-Winged Lord</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Blade Dive</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ignores Armor on Hot Shot</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">24</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Charnel Sphinx</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Crypt Riddle</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Forces random target swap</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">25</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Bloodroot Behemoth</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ground Slam</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">All enemies roll Disadvantage</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">30</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Cult Bladelord Revan</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">H</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Twin Slash</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Gains 1 Action if target drops</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">26</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Obsidian Leviathan</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Tectonic Charge</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Stuns enemies in line</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">28</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Pestilence Herald</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">D</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Breath of Rot</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">All enemies poisoned</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">25</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Gravemist Apparition</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Deathcoil</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">-2 to target&rsquo;s next roll</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">23</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Venomshade Ravager</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Toxic Bloom</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Creates poison zone</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">24</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Blackfang Juggernaut</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Maul and Crush</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Ignores first Block roll</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">29</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Mindflame Echo</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Dreamfire</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Causes hallucination (miss next turn)</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">24</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Daggermaw Tyrant</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">B</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Piercing Fang</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Forces reroll on successful Block</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">25</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Ghostrot Moth</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">A</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Luminous Shred</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Target makes next roll at Disadv</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">6</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">22</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Witherbark Horror</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">P</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">4</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Root Crush</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Terrain becomes difficult</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">8</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">27</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Gravetide Leviathan</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">U</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">5</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Bone Tide</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">d10</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Pushes all enemies 3 spaces</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">7</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">28</span></p>
        </td>
        </tr>
        </tbody>
        </table>
      </div>
    </div>
    <div id="questTable" class="collapse" data-bs-parent="#accordion">
      <div class="container">
        <table>
          <tbody>
          <tr>
          <td class="fill">
          <p><strong>d6</strong></p>
          </td>
          <td class="fill">
          <p><strong>Quest Type</strong></p>
          </td>
          </tr>
          <tr>
          <td>
          <p><span style="font-weight: 400;">1</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">Retrieval</span></p>
          </td>
          </tr>
          <tr>
          <td>
          <p><span style="font-weight: 400;">2</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">Escort</span></p>
          </td>
          </tr>
          <tr>
          <td>
          <p><span style="font-weight: 400;">3</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">Elimination</span></p>
          </td>
          </tr>
          <tr>
          <td>
          <p><span style="font-weight: 400;">4</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">Investigation</span></p>
          </td>
          </tr>
          <tr>
          <td>
          <p><span style="font-weight: 400;">5</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">Survival</span></p>
          </td>
          </tr>
          <tr>
          <td>
          <p><span style="font-weight: 400;">6</span></p>
          </td>
          <td>
          <p><span style="font-weight: 400;">Diplomacy</span></p>
          </td>
          </tr>
          </tbody>
          </table>
          <br>
          <table>
            <tbody>
            <tr>
            <td class="fill">
              #
            </td>
            <td class="fill">
              Hook
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">1</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A vision or dream calls the party to action.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">2</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A town is panicked over strange disappearances.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">3</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A cursed item changes hands in public.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">4</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A rival group challenges the party directly.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">5</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Someone offers gold for a shady job.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">6</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A creature escapes captivity and heads for the wild.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">7</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A storm uncovers ancient ruins.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">8</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A messenger collapses at the party&rsquo;s feet.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">9</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A mysterious fog rolls in with voices inside it.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">10</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A noble offers favor&hellip; for a favor.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">11</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A child has gone missing from a nearby village.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">12</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A caravan has stopped moving, its guards too afraid to explain why.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">13</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A creature has begun stalking travelers along a trade route.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">14</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A noble offers a reward for recovering a stolen heirloom.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">15</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A strange sickness has begun spreading in a border town.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">16</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Bandits have taken over an old fortress and begun raiding.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">17</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A local river has turned black and undrinkable.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">18</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">An earthquake revealed the entrance to a long-buried structure.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">19</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A ghostly figure appears nightly on a village hilltop.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">20</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A merchant hires the party to retrieve rare goods from a distant ruin.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">21</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Farmers report livestock being drained of blood.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">22</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A long-lost friend of a party member sends a cryptic message.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">23</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Locals whisper that a tree deep in the forest grants visions.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">24</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A wizard offers a map to a sealed tomb in exchange for a favor.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">25</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Every dog in a town begins howling at the same hour nightly.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">26</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A mirror in a ruined manor shows a reflection of another world.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">27</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Someone has poisoned the town&rsquo;s food supply, but no one knows who.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">28</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A massive tree begins bleeding sap that smells like blood.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">29</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">The party wakes up with no memory&mdash;and one is missing.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">30</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">The local temple&rsquo;s relic has gone missing under mysterious circumstances.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">31</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A talking raven follows the party and recites chilling prophecies.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">32</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A group of miners uncovered something strange&mdash;and sealed the tunnel.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">33</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Each morning, the town resets to the same day.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">34</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A hunter claims to have wounded a legendary beast and needs help tracking it.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">35</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">The moon hasn't risen in three nights.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">36</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A noble hires the party to recover a family member who joined a cult.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">37</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A strange fog rolls in, and those who enter it vanish.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">38</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Children across the land begin humming the same eerie tune.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">39</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Someone from the party&rsquo;s past arrives with a desperate plea.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">40</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A series of mysterious deaths all involve melted clocks.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">41</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Villagers claim their shadows have started acting independently.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">42</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A strange black flower is blooming where nothing should grow.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">43</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">The sky turns red for an hour each day&mdash;and it's getting longer.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">44</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A dying thief offers a map, a warning, and a name: &ldquo;The Hollow King.&rdquo;</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">45</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">An animal speaks aloud in a voice the party recognizes.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">46</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A forest path appears only during moonlight.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">47</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A cursed ship washes ashore&mdash;its crew are frozen mid-scream.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">48</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">The graves in a small village have been emptied from the inside.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">49</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Every door in town creaks open at the same time each night.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">50</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A golem sits silently in a clearing with a sword through its chest.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">51</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">The local innkeeper is a retired monster slayer&mdash;now hunted by something old.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">52</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A statue cries real tears once a week&mdash;then someone dies.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">53</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A hidden glade is said to heal wounds&mdash;but only if you leave something behind.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">54</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A once-dormant volcano begins to rumble.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">55</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A druid has gone mad and is reshaping the forest into a labyrinth.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">56</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A long-lost temple surfaces from the ocean depths.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">57</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A comet streaks across the sky, altering the behavior of animals nearby.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">58</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A local child draws pictures of events that haven&rsquo;t happened yet.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">59</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">The king&rsquo;s dreams are being tampered with by an external force.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">60</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A broken sword begins glowing when near a certain tomb.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">61</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A masked group begins appearing in towns before disasters.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">62</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A swamp is expanding rapidly and swallowing up villages.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">63</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A ghost ship sails across land during full moons.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">64</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A traveling merchant sells trinkets that begin to speak after midnight.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">65</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A group of refugees claim to have fled a walking city.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">66</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">The stars rearrange themselves into a new constellation overnight.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">67</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">The harvest festival ends with a blackout&mdash;and 30 people go missing.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">68</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A library&rsquo;s books have started rewriting themselves.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">69</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">An avalanche reveals the entrance to a forgotten prison.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">70</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">The party finds a silver mask that cannot be removed once worn.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">71</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Strange insects buzz words in a language no one knows.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">72</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A bard's song accidentally awakens something buried beneath the tavern.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">73</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">The dead are rising&mdash;but they aren't hostile, just confused.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">74</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A haunted battlefield replays the same moment over and over.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">75</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">A blood-red snow begins falling, even in summer.</span></p>
            </td>
            </tr>
            </tbody>
            </table>
            <br>
            <table>
            <tbody>
            <tr>
            <td class="fill">
            <p><strong>d8</strong></p>
            </td>
            <td class="fill">
            <p><strong>Twist</strong></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">1</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">The true villain is someone the party trusts.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">2</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">The objective is a fake or cursed.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">3</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Time is running out &mdash; something will awaken or collapse.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">4</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Another faction wants the same thing and is catching up.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">5</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">The locals have been lying.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">6</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">The party is blamed for something and hunted.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">7</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">The enemy is not evil &mdash; they&rsquo;re desperate or tricked.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">8</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">The quest leads to an ancient, locked power.</span></p>
            </td>
            </tr>
            </tbody>
          </table>
          <br>
          <table>
            <tbody>
            <tr>
            <td class="fill">
            <p><strong>Reward Type</strong></p>
            </td>
            <td class="fill">
            <p><strong>Examples</strong></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">Item</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Magic weapon, rare spell shard, cursed trinket</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">Knowledge</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Secret history, lost map, blackmail material</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">Favor</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Noble&rsquo;s debt, guild trust, monster allegiance</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">Territory</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Land grant, base of operations, sanctuary</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">Ally</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Beast companion, NPC fighter, ancient spirit</span></p>
            </td>
            </tr>
            </tbody>
          </table>
          <br>
          <table>
            <tbody>
            <tr>
            <td class="fill">
            <p><strong>Moral Crossroads</strong></p>
            </td>
            <td class="fill">
            <p><strong>Stakes</strong></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">Save the village or complete the mission?</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Sacrifice vs duty</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">Use a forbidden power or fall behind?</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Risk vs restraint</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">Spare a fallen foe or finish them?</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Mercy vs justice</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">Reveal the truth or keep peace?</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Honesty vs harmony</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">Trade their reward to save a stranger?</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Greed vs goodwill</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A town offers to pay the party if they cover up a local noble&rsquo;s crime.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Justice vs personal gain; protecting townsfolk reputation vs truth.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A monster begs for mercy, revealing it was cursed and once Man.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Slay it and collect a bounty, or break the curse and lose the reward?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A child possesses dangerous magical power they can&rsquo;t control.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Teach, contain, or eliminate? Do you trust the child or the frightened townsfolk?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A village is thriving due to a demon pact that demands one sacrifice per year.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Break the pact and risk famine or let it continue quietly?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A wounded enemy soldier begs for help, revealing vital military intelligence.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Save them and gain knowledge, or let them die and preserve moral high ground?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A city guardsman is punishing a thief for stealing food&mdash;but the thief was feeding orphans.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Intervene? What&rsquo;s more important&mdash;law or compassion?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A friendly NPC is secretly sabotaging the local government to install their own rule.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Do you expose them and risk chaos, or let them proceed and possibly improve the system?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A cursed object grants immense power, but slowly corrupts the user.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Destroy it, hide it, or use it for &ldquo;good&rdquo;?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A cleric asks the party to retrieve holy relics&mdash;but they&rsquo;re buried with innocent ancestors.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Desecrate a grave for a cause? Or respect the dead and decline?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">The party learns the orphanage they saved is funded by slave labor from overseas.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Shut it down and doom the kids, or let it persist while seeking change?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A tribe will go extinct unless the players intervene&mdash;but doing so means displacing another.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Who deserves the land more? Is interference justifiable?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A local legend speaks of a spirit protecting a forest, demanding a blood tithe yearly.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Reveal the truth and stop the ritual? Or is belief keeping order?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">An injured enemy reveals they&rsquo;re only fighting to protect their home from a greater evil.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Take advantage of their information&mdash;or ally with them and betray current allies?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A powerful wizard offers to teach the party, but only in exchange for a dangerous favor.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Gain powerful knowledge now or refuse and seek a safer route?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">The king is mad and cruel, but removing him would plunge the realm into civil war.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Quietly aid in regime change or try to reform from within?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A cursed adventurer is slowly transforming into a monster. They beg to join the party.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Help them while risking safety? Or deny them out of caution?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A town exiles non-humans "for safety"&mdash;they ask the party to enforce this.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Uphold the law or defy it and protect the innocent?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">An evil cultist wants to defect and help stop their leader&mdash;if you protect them from justice.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Do they deserve a second chance?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A foreign nation offers peace&mdash;if the party assassinates a rebellious general.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">End a war with blood on your hands or let the war rage?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A dragon demands tribute from nearby villages to avoid destruction. The tribute keeps peace.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Slay it and risk chaos, or let it rule from fear?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A dying rival offers a priceless artifact in exchange for a promise to raise their child.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Take the artifact and abandon the child, or honor the deal and gain a new responsibility?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A ghost begs to be reunited with their murderer in the afterlife &mdash; which requires a killing.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Help a soul find peace&hellip; through murder?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A warlord offers peace if you let them raze a rebellious village.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Sacrifice the few to save the many?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A friend confesses to a serious crime and asks for your silence.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Betray their trust to uphold justice, or cover for them and risk consequences?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A village demands execution of a harmless outsider due to an old superstition.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Protect the innocent or respect local beliefs?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A cult worships a benign nature spirit, but their rituals are gruesome.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Shut them down or allow their disturbing but peaceful ways?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A noble offers land if you quietly remove an obstacle (a political rival or peasant leader).</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Dirty your hands for long-term influence?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">You must choose to save a beloved NPC or a large group of strangers from a disaster.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Classic trolley problem.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A sentient sword begs not to be used for killing anymore.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Respect its wishes or override them for your survival?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A merchant offers to fund your mission if you burn down a rival&rsquo;s warehouse.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Take the help and hurt innocents, or decline and struggle?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A dying king wants you to forge a letter naming a just heir.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Forge for good? Or let politics take its messy course?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">An enemy offers to reveal crucial information&mdash;if you promise not to act on it.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Break your word or stick to honor?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A town's water supply is tainted. Fixing it will destroy a sacred relic site.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Protect health or history?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A plague is spreading. You have one cure. Use it on your ally or the healer who can make more?</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Short-term loyalty vs long-term survival.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A spirit offers great power in exchange for a piece of your soul.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Use it to save lives or refuse and risk failure?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A hidden faction begs you not to expose them, but doing so would end local corruption.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Expose them and save the town, or keep their secret and possibly gain a powerful ally?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">You&rsquo;re asked to marry a noble as a political gesture to unify warring factions.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Lose personal freedom for peace?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A magical storm threatens a region. Diverting it saves thousands but destroys a small town.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Who deserves protection more?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">An injured foe begs you to deliver a letter to their family.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Do you honor the request or ignore a killer&rsquo;s dying wish?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A captured bandit offers you their stash location if you let them go.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Justice or riches?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A dying god offers to make you their new vessel&mdash;at the cost of your identity.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Gain power but lose self?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A peace treaty can be signed, but only if you frame an innocent group.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Forge peace through lies?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">You discover a plot by a beloved leader to become a tyrant.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Expose them and break public trust, or work subtly behind the scenes?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A cursed artifact keeps a town prosperous but slowly poisons the land.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Break the curse and doom the town, or let them unknowingly suffer?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A cleric asks for help retrieving sacred texts from a rival temple.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Stealing? Reclaiming? Depends on who you ask.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">You can destroy a powerful relic or sell it to an evil collector.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">What&rsquo;s your price for temptation?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A friend asks you to lie during a major trial.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Loyalty vs legality.</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A monstrous race wants peace, but the locals want war.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Negotiate, mediate, or fight?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">You find a village living in denial about a looming threat.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Stir panic to prepare them or let them live their last days in peace?</span></p>
            </td>
            </tr>
            <tr>
            <td>
            <p><span style="font-weight: 400;">A necromancer raises the dead to protect the town. They're effective&mdash;but hated.</span></p>
            </td>
            <td>
            <p><span style="font-weight: 400;">Accept their methods or enforce moral purity?</span></p>
            </td>
            </tr>
            </tbody>
            </table>
      </div>
    </div>
    <div id="encounterTable" class="collapse" data-bs-parent="#accordion">
      <div class="container">
        <button id="enemyStatsButton"  class="ebut button fill" data-bs-toggle="collapse" data-bs-target="#lvl1">Enemy Stats 1</button>
        <button id="enemyStatsButton"  class="ebut button fill" data-bs-toggle="collapse" data-bs-target="#lvl2">Enemy Stats 2</button>
        <button id="enemyStatsButton"  class="button fill" data-bs-toggle="collapse" data-bs-target="#resetstats">Reset Stats</button>
      </div>
      <table class="container eTable">
        <tr id="lvl1" class="collapse">
          <td colspan="3" class="miniText">
            <table>
              <tr>
                <td class="p-2 fill cursor" colspan="" @click="lvl1stats()">Reset</td>
                <td class="p-2 fill"></td>
                <td class="p-2 fill"><input class="fill inputEnemy" placeholder="E 1" /></td>
                <td class="p-2 fill"></td>
                <td class="p-2 fill"></td>
                <td class="p-2 fill"><input class="fill inputEnemy" placeholder="E 2" /></td>
                <td class="p-2 fill"></td>
                <td class="p-2 fill"></td>
                <td class="p-2 fill"><input class="fill inputEnemy" placeholder="E 3" /></td>
                <td class="p-2 fill"></td>
              </tr>
              <tr>
                <td class="p-2 fill">
                  HP
                </td>
                <td class="p-2 fill cursor center" @click="hp1--; if (hp1 < 0) {hp1 = 0};">
                  -
                </td>
                <td class="p-2 fixedwidth2 cursor" @click="hp1 = Math.floor(Math.random() * 10) + 5;">
                  <input class="input_hp" v-model.number="hp1" />
                </td>
                <td class="p-2 fill cursor center" @click="hp1++; if (hp1 > 50) {hp1 = 50}">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="hp11--; if (hp11 < 0) {hp11 = 0};">
                  -
                </td>
                <td class="p-2 fixedwidth2 cursor" @click="hp11 = Math.floor(Math.random() * 10) + 5;">
                  <input class="input_hp" v-model.number="hp11" />
                </td>
                <td class="p-2 fill cursor center" @click="hp11++; if (hp11 > 50) {hp11 = 50}">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="hp111--; if (hp111 < 0) {hp111 = 0};">
                  -
                </td>
                <td class="p-2 fixedwidth2 cursor" @click="hp111 = Math.floor(Math.random() * 10) + 5;">
                  <input class="input_hp" v-model.number="hp111" />
                </td>
                <td class="p-2 fill cursor center" @click="hp111++; if (hp111 > 50) {hp111 = 50}">
                  +
                </td>
              </tr>
              <tr>
                <td class="p-2 fill">
                  AC
                </td>
                <td class="p-2 fill cursor center" @click="ac1--; if (ac1 < 0) {ac1 = 0};">
                  -
                </td>
                <td class="p-2 cursor" @click="ac1 = Math.floor(Math.random() * 4) + 6;">
                  <span class="input_hp">{{ ac1 }}</span>
                </td>
                <td class="p-2 fill cursor center" @click="ac1++; if (ac1 > 10) {ac1 = 10}">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="ac11--; if (ac11 < 1) {ac11 = 1};">
                  -
                </td>
                <td class="p-2 cursor" @click="ac11 = Math.floor(Math.random() * 4) + 6;">
                  <span class="input_hp">{{ ac11 }}</span>
                </td>
                <td class="p-2 fill cursor center" @click="ac11++; if (ac11 > 10) {ac11 = 10}">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="ac111--; if (ac111 < 1) {ac111 = 1};">
                  -
                </td>
                <td class="p-2 cursor" @click="ac111 = Math.floor(Math.random() * 4) + 6;">
                  <span class="input_hp">{{ ac111 }}</span>
                </td>
                <td class="p-2 fill cursor center" @click="ac111++; if (ac111 > 10) {ac111 = 10}">
                  +
                </td>
              </tr>
              <tr>
                <td class="p-2 fill">
                  MOV
                </td>
                <td class="p-2 fill cursor center" @click="move1--; if (move1 < 0) {move1 = 0};">
                  -
                </td>
                <td class="p-2">
                  <span class="input_hp">{{ move1 }}</span>
                </td>
                <td class="p-2 fill cursor center" @click="move1++; if (move1 > 10) {move1 = 10}">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="move11--; if (move11 < 0) {move11 = 0};">
                  -
                </td>
                <td class="p-2">
                  <span class="input_hp">{{ move11 }}</span>
                </td>
                <td class="p-2 fill cursor center" @click="move11++; if (move11 > 10) {move11 = 10}">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="move111--; if (move111 < 0) {move111 = 0};">
                  -
                </td>
                <td class="p-2">
                  <span class="input_hp">{{ move111 }}</span>
                </td>
                <td class="p-2 fill cursor center" @click="move111++; if (move111 > 10) {move111 = 10}">
                  +
                </td>
              </tr>
              <tr>
                <td class="p-2 fill">
                  MIG
                </td>
                <td class="p-2 fill cursor center" @click="mig1--; if (mig1 < 0) {mig1 = 0};">
                  -
                </td>
                <td class="p-2">
                  {{ mig1 }}
                </td>
                <td class="p-2 fill cursor center" @click="mig1++; if (mig1 > 5) {mig1 = 5};">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="mig11--; if (mig11 < 0) {mig11 = 0};">
                  -
                </td>
                <td class="p-2">
                  {{ mig11 }}
                </td>
                <td class="p-2 fill cursor center" @click="mig11++; if (mig11 > 5) {mig11 = 5};">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="mig111--; if (mig111 < 0) {mig111 = 0};">
                  -
                </td>
                <td class="p-2">
                  {{ mig111 }}
                </td>
                <td class="p-2 fill cursor center" @click="mig111++; if (mig111 > 5) {mig111 = 5};">
                  +
                </td>
              </tr>
              <tr>
                <td class="p-2 fill">
                  AGI
                </td>
                <td class="p-2 fill cursor center" @click="agi1--; if (agi1 < 0) {agi1 = 0};">
                  -
                </td>
                <td class="p-2">
                  {{ agi1 }}
                </td>
                <td class="p-2 fill cursor center"  @click="agi1++; if (agi1 > 5) {agi1 = 5};">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="agi11--; if (agi11 < 0) {agi11 = 0};">
                  -
                </td>
                <td class="p-2">
                  {{ agi11 }}
                </td>
                <td class="p-2 fill cursor center"  @click="agi11++; if (agi11 > 5) {agi11 = 5};">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="agi111--; if (agi111 < 0) {agi111 = 0};">
                  -
                </td>
                <td class="p-2">
                  {{ agi111 }}
                </td>
                <td class="p-2 fill cursor center"  @click="agi111++; if (agi111 > 5) {agi111 = 5};">
                  +
                </td>
              </tr>
              <tr>
                <td class="p-2 fill">
                  WIS
                </td>
                <td class="p-2 fill cursor center" @click="wis1--; if (wis1 < 0) {wis1 = 0};">
                  -
                </td>
                <td class="p-2">
                  {{ wis1 }}
                </td>
                <td class="p-2 fill cursor center"  @click="wis1++; if (wis1 > 5) {wis1 = 5};">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="wis11--; if (wis11 < 0) {wis11 = 0};">
                  -
                </td>
                <td class="p-2">
                  {{ wis11 }}
                </td>
                <td class="p-2 fill cursor center"  @click="wis11++; if (wis11 > 5) {wis11 = 5};">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="wis111--; if (wis111 < 0) {wis111 = 0};">
                  -
                </td>
                <td class="p-2">
                  {{ wis111 }}
                </td>
                <td class="p-2 fill cursor center"  @click="wis111++; if (wis111 > 5) {wis111 = 5};">
                  +
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr id="lvl2" class="collapse">
          <td colspan="3" class="miniText">
            <table>
              <tr>
                <td class="p-2 fill cursor" colspan="" @click="lvl1stats()">Reset</td>
                <td class="p-2 fill"></td>
                <td class="p-2 fill"><input class="fill inputEnemy" placeholder="E 4" /></td>
                <td class="p-2 fill"></td>
                <td class="p-2 fill"></td>
                <td class="p-2 fill"><input class="fill inputEnemy" placeholder="E 5" /></td>
                <td class="p-2 fill"></td>
                <td class="p-2 fill"></td>
                <td class="p-2 fill"><input class="fill inputEnemy" placeholder="E 6" /></td>
                <td class="p-2 fill"></td>
              </tr>
              <tr>
                <td class="p-2 fill">
                  HP
                </td>
                <td class="p-2 fill cursor center" @click="hp2--; if (hp2 < 0) {hp2 = 0};">
                  -
                </td>
                <td class="p-2 fixedwidth2 cursor" @click="hp2 = Math.floor(Math.random() * 10) + 5;">
                  <input class="input_hp" v-model.number="hp2" />
                </td>
                <td class="p-2 fill cursor center" @click="hp2++; if (hp2 > 50) {hp2 = 50}">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="hp22--; if (hp22 < 0) {hp22 = 0};">
                  -
                </td>
                <td class="p-2 fixedwidth2 cursor" @click="hp22 = Math.floor(Math.random() * 10) + 5;">
                  <input class="input_hp" v-model.number="hp22" />
                </td>
                <td class="p-2 fill cursor center" @click="hp22++; if (hp22 > 50) {hp22 = 50}">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="hp222--; if (hp222 < 0) {hp222 = 0};">
                  -
                </td>
                <td class="p-2 fixedwidth2 cursor" @click="hp222 = Math.floor(Math.random() * 10) + 5;">
                  <input class="input_hp" v-model.number="hp222" />
                </td>
                <td class="p-2 fill cursor center" @click="hp222++; if (hp222 > 50) {hp222 = 50}">
                  +
                </td>
              </tr>
              <tr>
                <td class="p-2 fill">
                  AC
                </td>
                <td class="p-2 fill cursor center" @click="ac2--; if (ac2 < 1) {ac2 = 1};">
                  -
                </td>
                <td class="p-2 cursor" @click="ac2 = Math.floor(Math.random() * 4) + 6;">
                  <span class="input_hp">{{ ac2 }}</span>
                </td>
                <td class="p-2 fill cursor center" @click="ac2++; if (ac2 > 10) {ac2 = 10}">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="ac22--; if (ac22 < 1) {ac22 = 1};">
                  -
                </td>
                <td class="p-2 cursor" @click="ac22 = Math.floor(Math.random() * 4) + 6;">
                  <span class="input_hp">{{ ac22 }}</span>
                </td>
                <td class="p-2 fill cursor center" @click="ac22++; if (ac22 > 10) {ac22 = 10}">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="ac222--; if (ac222 < 1) {ac222 = 1};">
                  -
                </td>
                <td class="p-2 cursor" @click="ac222 = Math.floor(Math.random() * 4) + 6;">
                  <span class="input_hp">{{ ac222 }}</span>
                </td>
                <td class="p-2 fill cursor center" @click="ac222++; if (ac222 > 10) {ac222 = 10}">
                  +
                </td>
              </tr>
              <tr>
                <td class="p-2 fill">
                  MOV
                </td>
                <td class="p-2 fill cursor center" @click="move2--; if (move2 < 0) {move2 = 0};">
                  -
                </td>
                <td class="p-2">
                  <span class="input_hp">{{ move1 }}</span>
                </td>
                <td class="p-2 fill cursor center" @click="move2++; if (move2 > 10) {move2 = 10}">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="move22--; if (move22 < 0) {move22 = 0};">
                  -
                </td>
                <td class="p-2">
                  <span class="input_hp">{{ move22 }}</span>
                </td>
                <td class="p-2 fill cursor center" @click="move22++; if (move22 > 10) {move22 = 10}">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="move222--; if (move222 < 0) {move222 = 0};">
                  -
                </td>
                <td class="p-2">
                  <span class="input_hp">{{ move222 }}</span>
                </td>
                <td class="p-2 fill cursor center" @click="move222++; if (move222 > 10) {move222 = 10}">
                  +
                </td>
              </tr>
              <tr>
                <td class="p-2 fill">
                  MIG
                </td>
                <td class="p-2 fill cursor center" @click="mig2--; if (mig2 < 0) {mig2 = 0};">
                  -
                </td>
                <td class="p-2">
                  {{ mig2 }}
                </td>
                <td class="p-2 fill cursor center" @click="mig2++; if (mig2 > 5) {mig2 = 5};">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="mig22--; if (mig22 < 0) {mig22 = 0};">
                  -
                </td>
                <td class="p-2">
                  {{ mig22 }}
                </td>
                <td class="p-2 fill cursor center" @click="mig22++; if (mig22 > 5) {mig22 = 5};">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="mig222--; if (mig222 < 0) {mig222 = 0};">
                  -
                </td>
                <td class="p-2">
                  {{ mig222 }}
                </td>
                <td class="p-2 fill cursor center" @click="mig222++; if (mig222 > 5) {mig222 = 5};">
                  +
                </td>
              </tr>
              <tr>
                <td class="p-2 fill">
                  AGI
                </td>
                <td class="p-2 fill cursor center" @click="agi2--; if (agi2 < 0) {agi2 = 0};">
                  -
                </td>
                <td class="p-2">
                  {{ agi2 }}
                </td>
                <td class="p-2 fill cursor center"  @click="agi2++; if (agi2 > 5) {agi2 = 5};">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="agi22--; if (agi22 < 0) {agi22 = 0};">
                  -
                </td>
                <td class="p-2">
                  {{ agi22 }}
                </td>
                <td class="p-2 fill cursor center"  @click="agi22++; if (agi22 > 5) {agi22 = 5};">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="agi222--; if (agi222 < 0) {agi222 = 0};">
                  -
                </td>
                <td class="p-2">
                  {{ agi222 }}
                </td>
                <td class="p-2 fill cursor center"  @click="agi222++; if (agi222 > 5) {agi222 = 5};">
                  +
                </td>
              </tr>
              <tr>
                <td class="p-2 fill">
                  WIS
                </td>
                <td class="p-2 fill cursor center" @click="wis2--; if (wis2 < 0) {wis2 = 0};">
                  -
                </td>
                <td class="p-2">
                  {{ wis2 }}
                </td>
                <td class="p-2 fill cursor center"  @click="wis2++; if (wis2 > 5) {wis2 = 5};">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="wis22--; if (wis22 < 0) {wis22 = 0};">
                  -
                </td>
                <td class="p-2">
                  {{ wis22 }}
                </td>
                <td class="p-2 fill cursor center"  @click="wis22++; if (wis22 > 5) {wis22 = 5};">
                  +
                </td>
                <td class="p-2 fill cursor center" @click="wis222--; if (wis222 < 0) {wis222 = 0};">
                  -
                </td>
                <td class="p-2">
                  {{ wis222 }}
                </td>
                <td class="p-2 fill cursor center"  @click="wis222++; if (wis222 > 5) {wis222 = 5};">
                  +
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      <table id="resetstats" class="container collapse">
        <tr>
          <td class="p-2 fill cursor zero-padding" colspan="" @click="all5HP()">Reset All to 5 HP</td>
          <td class="p-2 fill cursor zero-padding" colspan="" @click="all10HP()">Reset All to 10 HP</td>
        </tr>
        <tr>
          <td class="p-2 fill cursor zero-padding" colspan="" @click="all6AC()">Reset All to 6 AC</td>
          <td class="p-2 fill cursor zero-padding" colspan="" @click="all10AC()">Reset All to 10 AC</td>
        </tr>
      </table>
      <!-- <br><br> -->
      <table class="dmTable container">
        <tr>
          <td class="fill p-2 center cursor encounter_heading" data-bs-toggle="collapse" data-bs-target="#encounterTable"><p class="top-space">Encounter</p></td>
          <td colspan="2" class="fill center cursor"  @click="resetEncounter()"><i class="fa-solid fa-rotate-right center"></i></td>
        </tr>
        
        <tr>
          <td class="fill center encounter p-2">Number of Creatures</td>                                
          <td class="p-2">{{ creatureNumberResponse }}</td>
          <td class="fixed black-border fill center cursor" @click="randomizeNumberOfCreatures();"><i class="fa-solid fa-rotate-right center"></i></td> 
        </tr>
        <tr>
          <td class="fill center encounter p-2">Creature Types</td>                                     
          <td class="p-2">{{ creatureTypeResponse }}</td>
          <td class="fixed black-border fill center"        @click="randomizeCreatureTypes()"></td> 
        </tr>
        <tr>
          <td class="fill center encounter p-2">Behavior</td>                                     
          <td class="p-2">{{ creatureBehaviorResponse1 }}<br><br>{{ creatureBehaviorResponse2 }}<br><br>{{ creatureBehaviorResponse3 }}</td>
          <td class="fixed black-border fill center cursor" @click="randomizeBehavior()"><i class="fa-solid fa-rotate-right"></i></td> 
        </tr>
        <tr>
          <td class="fill center encounter p-2">Weather</td>                                            
          <td class="p-2">{{ weatherResponse }}</td>
          <td class="fixed black-border fill center cursor" @click="randomizeWeather()"><i class="fa-solid fa-rotate-right"></i></td> 
        </tr>
        <tr>
          <td class="fill center encounter p-2">Environment</td>                                        
          <td class="p-2">{{ environmentResponse1 }}<br>{{ environmentResponse2 }}<br>{{ environmentResponse3 }}<br>{{ environmentResponse4 }}</td>
          <td class="fixed black-border fill center cursor" @click="randomizeEnvironment()"><i class="fa-solid fa-rotate-right"></i></td> 
        </tr>
        <tr>
          <td class="fill center encounter p-2">Loot</td>                                               
          <td class="p-2"><u><b>{{ loot }}</b></u><br> {{ lootResponse }}</td>
          <td class="fixed black-border fill center cursor" @click="randomizeLoot()"><i class="fa-solid fa-rotate-right"></i></td> 
        </tr>
        <tr>
          <td class="fill center encounter p-2">Weapon</td>                                               
          <td class="p-2">{{ weaponResponse }}</td>
          <td class="fixed fill center cursor" @click="randomizeWeapon()"><i class="fa-solid fa-rotate-right"></i></td> 
        </tr>
      </table>
      <br><br>
      <table class="dmTable container">
        <tr>
          <td class="fill center encounter p-2">Might</td>
          <td class="p-2">
            <b>6+ (Success)</b>: You overcome the obstacle by force or endurance.<br>
            <b>NAT 10</b>: You exceed expectations — it holds, you inspire others, or deal collateral damage to an obstacle.<br>
            <b>≤5 (Failure)</b>: You tire yourself, strain equipment, or create noise.<br>
            <b>NAT 1</b>: You injure yourself or make the situation worse (collapse, breakage, exposure).
          </td>
        </tr>
        <tr>
          <td class="fill center encounter p-2">Agility</td>
          <td class="p-2">
            <b>6+ (Success)</b>: You perform the task smoothly.<br>
            <b>NAT 10</b>: You succeed flawlessly — fast, silent, or pick up something extra.<br>
            <b>≤5 (Failure)</b>: You stumble, slow down, or partially expose yourself.<br>
            <b>NAT 1</b>: You fall, fumble, or attract unwanted attention.
          </td>
        </tr>
        <tr>
          <td class="fill center encounter p-2">Wisdom</td>
          <td class="p-2">
            <b>6+ (Success)</b>: You understand or notice what is needed.<br>
            <b>NAT 10</b>: You gain extra insight — hidden detail, clue, or intuition.<br>
            <b>≤5 (Failure)</b>: You misread or overlook something minor.<br>
            <b>NAT 1</b>: You are misled, give false info, or act on a wrong assumption.<br>
          </td>
        </tr>
      </table>
      </div>
      <!-- <div class="container"> -->
      <br>
      <div id="magicWeaponsTable" class="collapse container">
        <h2><strong>Might</strong></h2>
        <table>
          <tbody>
          <tr>
          <td class="fill b-right short">
            <strong>DR:</strong> d8 + MIG
          <p><strong>Base Range:</strong> 2</p>
          </td>
          <td class="fill b-left">
          <h2><strong>Hot Shot</strong></h2>
          </td>
          </tr>
          <tr>
          <td>
          M1
          </td>
          <td>
          All enemies within Range take +1 damage.
          </td>
          </tr>
          <tr>
          <td>
          M2
          </td>
          <td>
          Your next Attack Roll on this turn or next turn has ADV.
          </td>
          </tr>
          <tr>
          <td>
          M3
          </td>
          <td>
          This Weapon has +2 Range until the end of your next turn. 
          </td>
          </tr>
          <tr>
          <td>
          M4
          </td>
          <td>
          Add +d4 to the damage.
          </td>
          </tr>
          <tr>
          <td>
          M5
          </td>
          <td>
          All enemies within Range have their next Attack Roll reduced by -1 until the start of your next turn, unless it's a NAT 10.
          </td>
          </tr>
          <tr>
          <!-- <td> -->
          </tr>
          </tbody>
        </table>
        <br>
          <h2><strong>Agility</strong></h2>
          
        <table>
          <tbody>
          <tr>
          <td class="fill b-right short">
          <strong>DR:</strong> d4 + AGI
          <p><strong>Base Range:</strong> 6</p>
          </td>
          <td class="fill b-left">
          <h2><strong>Hot Shot</strong></h2>
          </td>
          </tr>
          <tr>
          <td>
          A1
          </td>
          <td>
          Add +d4 to the damage.
          </td>
          </tr>
          <tr>
          <td>
          Crossbow
          </td>
          <td>
          Your next Attack Roll on this turn has ADV.
          </td>
          </tr>
          <tr>
          <td>
          A3
          </td>
          <td>
          The target's next Attack Roll has DIS until the start of your next turn.
          </td>
          </tr>
          <tr>
          <td>
          Longbow
          </td>
          <td>
          Roll d8 + AGI for the DR and add +1 damage if you roll an 8.
          </td>
          </tr>
          <tr>
          <td>
          A5
          </td>
          <td>
          The target's Armor is reduced by -1 until it is hit until the start of your next turn.
          </td>
          </tr>
          </tbody>
        </table>
        <br>
          <h2><strong>Wisdom</strong></h2>
        <table>
          <tbody>
          <tr>
          <td class="fill b-right short">
          <strong>DR:</strong>
          d6 + WIS
          <p><strong>Base Range:</strong> 4</p>
          </td>
          <td class="fill b-left">
          <h2><strong>Hot Shot</strong></h2>
          </td>
          </tr>
          <tr>
          <td>
          W1
          </td>
          <td>
          All enemies within Range have their next Attack Roll reduced by -1 until the start of your next turn, unless it's a NAT 10.
          </td>
          </tr>
          <tr>
          <td>
          W2
          </td>
          <td>
          All enemies within Range deal -1 damage to a min of 1 per Attack until the end of their next turn.
          </td>
          </tr>
          <tr>
          <td>
          W3
          </td>
          <td>
          All enemies within Range have their Armor reduced by -1 until they are hit until the start of your next turn.
          </td>
          </tr>
          <tr>
          <td>
          W4
          </td>
          <td>
          Regain the same number of HP as the damage.
          </td>
          </tr>
          <tr>
          <td>
          W5
          </td>
          <td>
          All enemies in Range take +1 damage including your original target.
          </td>
          </tr>
          </tbody>
        </table>
        <br>
        <!-- </div> -->
        <table class="dmTable container">
        <tr>
        <td class="fill">Weapon</td>
        <td class="fill">Sharpen</td>
        <td class="fill">Balance</td>
        <td class="fill">Reinforce</td>
        <td class="fill">Lengthen</td>
        </tr>
        <tr>
        <td><strong>M4</strong></td>
        <td>250G</td>
        <td>190G</td>
        <td>220G</td>
        <td>125G</td>
        </tr>
        <tr>
        <td><strong>M2</strong></td>
        <td>200G</td>
        <td>150G</td>
        <td>175G</td>
        <td>100G</td>
        </tr>
        <tr>
        <td><strong>M1</strong></td>
        <td>200G</td>
        <td>150G</td>
        <td>175G</td>
        <td>100G</td>
        </tr>
        <tr>
        <td><strong>M3</strong></td>
        <td>250G</td>
        <td>190G</td>
        <td>220G</td>
        <td>125G</td>
        </tr>
        <tr>
        <td><strong>M5</strong></td>
        <td>150G</td>
        <td>110G</td>
        <td>130G</td>
        <td>75G</td>
        </tr>
        <tr>
        <td><strong>Longbow</strong></td>
        <td>300G</td>
        <td>225G</td>
        <td>260G</td>
        <td>150G</td>
        </tr>
        <tr>
        <td><strong>A1</strong></td>
        <td>250G</td>
        <td>190G</td>
        <td>220G</td>
        <td>125G</td>
        </tr>
        <tr>
        <td><strong>Crossbow</strong></td>
        <td>200G</td>
        <td>150G</td>
        <td>175G</td>
        <td>100G</td>
        </tr>
        <tr>
        <td><strong>A3 Throw</strong></td>
        <td>150G</td>
        <td>110G</td>
        <td>130G</td>
        <td>75G</td>
        </tr>
        <tr>
        <td><strong>A5 Throw</strong></td>
        <td>200G</td>
        <td>150G</td>
        <td>175G</td>
        <td>100G</td>
        </tr>
        <tr>
        <td><strong>W5</strong></td>
        <td>190G</td>
        <td>260G</td>
        <td>300G</td>
        <td>150G</td>
        </tr>
        <tr>
        <td><strong>W4</strong></td>
        <td>190G</td>
        <td>260G</td>
        <td>300G</td>
        <td>150G</td>
        </tr>
        <tr>
        <td><strong>W2</strong></td>
        <td>160G</td>
        <td>220G</td>
        <td>250G</td>
        <td>125G</td>
        </tr>
        <tr>
        <td><strong>W1</strong></td>
        <td>125G</td>
        <td>175G</td>
        <td>200G</td>
        <td>100G</td>
        </tr>
        <tr>
        <td><strong>W3</strong></td>
        <td>95G</td>
        <td>130G</td>
        <td>150G</td>
        <td>75G</td>
        </tr>
        </table>
        <br><br>
        <table class="dmTable container">
        <tr>
        <td class="fill">Weapon</td>
        <td class="fill">Sharpen</td>
        <td class="fill">Balance</td>
        <td class="fill">Reinforce</td>
        <td class="fill">Lengthen</td>
        <td class="fill">Enchant</td>
        <td class="fill">Bless</td>
        <td class="fill">Hex</td>
        </tr>
        <tr>
        <td>M1</td>
        <td>✅</td>
        <td>🚫</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        </tr>
        <tr>
        <td>M2</td>
        <td>🚫</td>
        <td>🚫</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        </tr>
        <tr>
        <td>M3</td>
        <td>🚫</td>
        <td>🚫</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        </tr>
        <tr>
        <td>M4</td>
        <td>🚫</td>
        <td>✅</td>
        <td>✅</td>
        <td>🚫</td>
        <td>✅</td>
        <td>🚫</td>
        <td>✅</td>
        </tr>
        <tr>
        <td>M5</td>
        <td>🚫</td>
        <td>🚫</td>
        <td>🚫</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        <td>🚫</td>
        </tr>
        <tr>
        <td>Crossbow</td>
        <td>🚫</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        </tr>
        <tr>
        <td>A3</td>
        <td>✅</td>
        <td>🚫</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        <td>🚫</td>
        </tr>
        <tr>
        <td>Longbow</td>
        <td>🚫</td>
        <td>✅</td>
        <td>✅</td>
        <td>🚫</td>
        <td>✅</td>
        <td>🚫</td>
        <td>✅</td>
        </tr>
        <tr>
        <td>A5</td>
        <td>✅</td>
        <td>✅</td>
        <td>🚫</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        </tr>
        <tr>
        <td>A1</td>
        <td>🚫</td>
        <td>✅</td>
        <td>✅</td>
        <td>🚫</td>
        <td>✅</td>
        <td>🚫</td>
        <td>✅</td>
        </tr>
        <tr>
        <td>W2</td>
        <td>🚫</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        </tr>
        <tr>
        <td>W3</td>
        <td>🚫</td>
        <td>✅</td>
        <td>🚫</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        </tr>
        <tr>
        <td>W5</td>
        <td>🚫</td>
        <td>✅</td>
        <td>✅</td>
        <td>🚫</td>
        <td>✅</td>
        <td>🚫</td>
        <td>✅</td>
        </tr>
        <tr>
        <td>W4</td>
        <td>🚫</td>
        <td>✅</td>
        <td>✅</td>
        <td>🚫</td>
        <td>✅</td>
        <td>🚫</td>
        <td>✅</td>
        </tr>
        <tr>
        <td>W1</td>
        <td>🚫</td>
        <td>🚫</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        <td>✅</td>
        <td>🚫</td>
        </tr>
        </table>
        <br><br>
        <table class="potionCostTable dmTable container">
          <tr><td class="width25 p-2 fill">Magic</td> <td class="width50 p-2 fill">Skill</td><td class="width50 p-2 fill">Bonus</td></tr>
          <tr><td class="width25 p-2">1</td>          <td class="width50 p-2">MIG</td><td class="width50 p-2">+1 DMG for 1 creature type</td></tr>
          <tr><td class="width25 p-2">2</td>          <td class="width50 p-2">MIG</td><td class="width50 p-2">-1 Armor for 1 creature type</td></tr>
          <tr><td class="width25 p-2">3</td>          <td class="width50 p-2">MIG</td><td class="width50 p-2">ADV for 1 creature type once per turn</td></tr>
          <tr><td class="width25 p-2">4</td>          <td class="width50 p-2">AGI</td><td class="width50 p-2">+1 DMG for 1 creature type</td></tr>
          <tr><td class="width25 p-2">5</td>          <td class="width50 p-2">AGI</td><td class="width50 p-2">-1 Armor for 1 creature type</td></tr>
          <tr><td class="width25 p-2">6</td>          <td class="width50 p-2">AGI</td><td class="width50 p-2">ADV for 1 creature type once per turn</td></tr>
          <tr><td class="width25 p-2">7</td>          <td class="width50 p-2">WIS</td><td class="width50 p-2">+1 DMG for 1 creature type</td></tr>
          <tr><td class="width25 p-2">8</td>          <td class="width50 p-2">WIS</td><td class="width50 p-2">-1 Armor for 1 creature type</td></tr>
          <tr><td class="width25 p-2">9</td>          <td class="width50 p-2">WIS</td><td class="width50 p-2">ADV for 1 creature type once per turn</td></tr>
          <br><br>
          <tr><td class="width25 p-2 fill">Curse</td> <td class="width50 p-2 fill">Skill</td><td class="width50 p-2 fill">Curse</td></tr>
          <tr><td class="width25 p-2">1</td>          <td class="width50 p-2">MIG</td><td class="width50 p-2">-1 DMG for 1 creature type</td></tr>
          <tr><td class="width25 p-2">2</td>          <td class="width50 p-2">MIG</td><td class="width50 p-2">+1 Armor for 1 creature type</td></tr>
          <tr><td class="width25 p-2">3</td>          <td class="width50 p-2">MIG</td><td class="width50 p-2">DIS for 1 creature type</td></tr>
          <tr><td class="width25 p-2">4</td>          <td class="width50 p-2">AGI</td><td class="width50 p-2">-1 DMG for 1 creature type</td></tr>
          <tr><td class="width25 p-2">5</td>          <td class="width50 p-2">AGI</td><td class="width50 p-2">+1 Armor for 1 creature type</td></tr>
          <tr><td class="width25 p-2">6</td>          <td class="width50 p-2">AGI</td><td class="width50 p-2">DIS for 1 creature type</td></tr>
          <tr><td class="width25 p-2">7</td>          <td class="width50 p-2">WIS</td><td class="width50 p-2">+1 Armor for 1 creature type</td></tr>
          <tr><td class="width25 p-2">8</td>          <td class="width50 p-2">WIS</td><td class="width50 p-2">-1 Armor for 1 creature type</td></tr>
          <tr><td class="width25 p-2">9</td>          <td class="width50 p-2">WIS</td><td class="width50 p-2">DIS for 1 creature type</td></tr>
        </table>
      </div>
      <div id="foodTable" class="collapse container">
        <table>
          <tr>
            <td colspan="3" class="fill p-2 top-space">
              Food & Drug
            </td>
          </tr>
          <!-- <tr><td class="width25 p-2">Potion of Minor Healing</td><td class="width10 p-2">5g</td>     <td class="width50 p-2">+1 HP</td></tr> -->
          <!-- <tr><td class="width25 p-2">Potion of Greater Healing</td><td class="width10 p-2">25g</td>  <td class="width50 p-2">+1d8 HP</td></tr> -->
          <!-- <tr><td class="width25 p-2">Bountiful Meal</td>         <td class="width10 p-2">30g</td>    <td class="width50 p-2">+2d6 HP</td></tr> -->
          <!-- <tr><td class="width25 p-2">Orc Oats</td>               <td class="width10 p-2">50g</td>    <td class="width50 p-2">+2 Damage for 1 ATK</td></tr> -->
          <tr><td class="width25 p-2">Potion of Healing</td>      <td class="width10 p-2">10g</td>    <td class="width50 p-2">+1d4 HP</td></tr>
          <tr><td class="width25 p-2">Potion of Full Healing</td> <td class="width10 p-2">300g</td>   <td class="width50 p-2">Full HP</td></tr>
          <tr><td class="width25 p-2">Basic Meal</td>             <td class="width10 p-2">15g</td>    <td class="width50 p-2">+1d6 HP</td></tr>
          <tr><td class="width25 p-2">Ale</td>                    <td class="width10 p-2">5g</td>     <td class="width50 p-2">+1 damage for 1 ATK</td></tr>
          <tr><td class="width25 p-2">Swamp Grog</td>             <td class="width10 p-2">10g</td>    <td class="width50 p-2">+1 to 1 Action Roll (no Hot Shot unless 10 is rolled on die)</td></tr>
          <tr><td class="width25 p-2">Booster Juice</td>          <td class="width10 p-2">20g</td>    <td class="width50 p-2">+1 Armor to a max of 10 until the start of your next turn</td></tr>
          <tr><td class="width25 p-2">Dwarf Dust</td>             <td class="width10 p-2">50g</td>    <td class="width50 p-2">ADV for 1 Might Attack</td></tr>
          <tr><td class="width25 p-2">Elf Elixer</td>             <td class="width10 p-2">50g</td>    <td class="width50 p-2">ADV for 1 Agility Attack</td></tr>
          <tr><td class="width25 p-2">Halfling Honey</td>         <td class="width10 p-2">50g</td>    <td class="width50 p-2">ADV for 1 Wisdom Attack</td></tr>
          <tr><td class="width25 p-2">Fighter Figs</td>           <td class="width10 p-2">40g</td>    <td class="width50 p-2">+1d6 damage for 1 Might Attack</td></tr>
          <tr><td class="width25 p-2">Monk Mead</td>              <td class="width10 p-2">40g</td>    <td class="width50 p-2">+1d6 damage for 1 Agility Attack</td></tr>
          <tr><td class="width25 p-2">Mage Milk</td>              <td class="width10 p-2">40g</td>    <td class="width50 p-2">+1d6 damage for 1 Wisdom Attack</td></tr>
          <tr><td class="width25 p-2">Moonsugar</td>              <td class="width10 p-2">150g</td>   <td class="width50 p-2">All enemies within 4 spaces have Armor -1 until the start of your next turn</td></tr>
          <tr><td class="width25 p-2">Sunspice</td>               <td class="width10 p-2">150g</td>   <td class="width50 p-2">All enemies within 4 spaces take +1 damage</td></tr>
          <tr><td class="width25 p-2">Vigor</td>                  <td class="width10 p-2">50g</td>    <td class="width50 p-2">The next Attack against you is made with DIS</td></tr>
        </table>
      </div>
      <br>
      <div id="creatureTypesTable" class="collapse container" data-bs-parent="#accordion">
        <!-- <div id="creaturesTypesTable" class="show"> -->
        
        <table class="dmTable container">
          <tr>
            <td class="fill p-2" data-bs-toggle="collapse" data-bs-target="#creaturesTypesTable">Creature Types</td>
          </tr>
          <tr>
            <td class="p-2">1. Apparition</td>
          </tr>
          <tr>
            <td class="p-2">2. Beast</td>
          </tr>
          <tr>
            <td class="p-2">3. Demon</td>
          </tr>
          <tr>
            <td class="p-2">4. Man</td>
          </tr>
          <tr>
            <td class="p-2">5. Plant</td>
          </tr>
          <tr>
            <td class="p-2">6. Undead</td>
          </tr>
        </table>
      </div>
    </div>
    <br><br>
    <br class="noshow"><br class="noshow">
    <br class="noshow"><br class="noshow">
    <br class="noshow"><br class="noshow">
    <br class="noshow"><br class="noshow">
  </div>
</template>
<script setup>
import { ref } from 'vue'


const hp1 = ref(0);
</script>
<script>
import Dice2 from '../components/Dice2';
import { ref } from 'vue';
// import { onMounted } from 'vue';


export default {
  components: {
    Dice2,
  },
  data() {
    return {
      encountersPerLRResponse: '',
      creatureNumberResponse: '',
      creatureTypeResponse: '',
      creatureBehaviorResponse1: '',
      creatureBehaviorResponse2: '',
      creatureBehaviorResponse3: '',
      disabled: '',
      environmentResponse1: '',
      environmentResponse2: '',
      environmentResponse3: '',
      environmentResponse4: '',
      weatherResponse: '',
      weaponResponse: '',
      lootResponse: '',
      loot: '',
      nr: '',
      instantSaveResponse: '',
      dcResponse: '',
      getValue: '',
      ac1: Math.floor(Math.random() * 4) + 6,
      move1: 5,
      hp1: Math.floor(Math.random() * 10) + 5,
      mig1: 0,
      agi1: 0,
      wis1: 0,
      ac11: Math.floor(Math.random() * 4) + 6,
      move11: 5,
      hp11: Math.floor(Math.random() * 10) + 5,
      mig11: 0,
      agi11: 0,
      wis11: 0,
      ac111: Math.floor(Math.random() * 4) + 6,
      move111: 5,
      hp111: Math.floor(Math.random() * 10) + 5,
      mig111: 0,
      agi111: 0,
      wis111: 0,

      ac2: Math.floor(Math.random() * 4) + 6,
      move2: 5,
      hp2: Math.floor(Math.random() * 10) + 5,
      mig2: 0,
      agi2: 0,
      wis2: 0,
      ac22: Math.floor(Math.random() * 4) + 6,
      move22: 5,
      hp22: Math.floor(Math.random() * 10) + 5,
      mig22: 0,
      agi22: 0,
      wis22: 0,
      ac222: Math.floor(Math.random() * 4) + 6,
      move222: 5,
      hp222: Math.floor(Math.random() * 10) + 5,
      mig222: 0,
      agi222: 0,
      wis222: 0,
    }
  },
  methods: {
    getRandomInt(max) {
      return Math.floor(Math.random() * max);
    },
    lvl1stats() {
      this.ac1    = Math.floor(Math.random() * 4) + 6;
      this.move1  = 5;
      this.hp1    = Math.floor(Math.random() * 10) + 5;
      this.mig1   = 0;
      this.agi1   = 0;
      this.wis1   = 0;
      this.ac11   = Math.floor(Math.random() * 4) + 6;
      this.move11 = 5;
      this.hp11   = Math.floor(Math.random() * 10) + 5;
      this.mig11  = 0;
      this.agi11  = 0;
      this.wis11  = 0;
      this.ac111  = Math.floor(Math.random() * 4) + 6;
      this.move111= 5;
      this.hp111  = Math.floor(Math.random() * 10) + 5;
      this.mig111 = 0;
      this.agi111 = 0;
      this.wis111 = 0;
    },
    all5HP() {
      this.hp1    = 5;
      this.hp11   = 5;
      this.hp111  = 5;
      this.hp2    = 5;
      this.hp22   = 5;
      this.hp222  = 5;
    },
    all10HP() {
      this.hp1    = 10;
      this.hp11   = 10;
      this.hp111  = 10;
      this.hp2    = 10;
      this.hp22   = 10;
      this.hp222  = 10;
    },
    all20HP() {
      this.hp1    = 20;
      this.hp11   = 20;
      this.hp111  = 20;
      this.hp2    = 20;
      this.hp22   = 20;
      this.hp222  = 20;
    },
    all6AC() {
      this.ac1    = 6;
      this.ac11   = 6;
      this.ac111  = 6;
      this.ac2    = 6;
      this.ac22   = 6;
      this.ac222  = 6;
    },
    all10AC() {
      this.ac1    = 10;
      this.ac11   = 10;
      this.ac111  = 10;
      this.ac2    = 10;
      this.ac22   = 10;
      this.ac222  = 10;
    },
    // dc response
    resetDC() {
      this.dcResponse = "";
    },
    randomizeNumberOfCreatures() {
      let n = this.getRandomInt(6) + 1;
      let nr = '';
      switch (n) {
        case 1:
          nr = "1";
          break;
        case 2:
          nr = "2";
          break;
        case 3:
          nr = "3";
          break;
        case 4:
          nr = "4";
          break;
        case 5:
          nr = "5";
          break;
        case 6:
          nr = "6";
          break;
      }
      // document.getElementById("creatureNumberResponse").innerHTML = nr;
      this.randomizeCreatureTypes(nr);
      this.creatureNumberResponse = nr; // gets passed to randomizeCreatureType
    },
    randomizeCreatureTypes(nr) {
      let array = [ "Apparition",
                    "Beast",
                    "Demon",
                    "Man",
                    "Plant",
                    "Undead"
                    ];
      let getValue = '';
      nr = Number(nr);
      
      for (let i = 0; i < nr; i++) {
        getValue += array[this.getRandomInt(6)] + ', ';
      }
      getValue = getValue.substring(0, getValue.length - 2); // -2 removes space and comma
      
      this.creatureTypeResponse = getValue;
    },
    // behavior
    randomizeBehavior: function () {
      let array = ["Heal", 
                  "Heal", 
                  "Heal", 
                  "Retreat",
                  "Retreat", 
                  "Block", 
                  "Attack Closest", 
                  "Attack Closest", 
                  "Attack Closest",
                  "Attack Closest", 
                  "Attack Closest", 
                  "Attack Closest",
                  "Attack Closest", 
                  "Attack Closest", 
                  "Attack Closest", 
                  "Attack Farthest", 
                  "Attack Farthest",
                  "Attack Last Healed", 
                  "Attack Last Healed",
                  "Attack Which Last Hit You",
                  "Attack Which Last Hit You",
                  "Attack Which Last Hit You",
                  "Attack Which Last Hit You",
                  "Attack Which Last Hit You",
                  "Attack Which Last Hit You",
                  "Attack Which Last Hit You",
                  "Attack Which You Last Hit",
                  "Attack Which You Last Targeted", 
                  "Attack Which You Last Targeted",
                  "Attack Which Last Targeted You", 
                  "Attack Which Last Targeted You",
                  "Attack Highest AC", 
                  "Attack Lowest AC", 
                  "Attack Highest HP", 
                  "Attack Lowest HP",
                  ];
      let getValue1 = array[this.getRandomInt(35)]; 
      let getValue2 = array[this.getRandomInt(35)];
      let getValue3 = array[this.getRandomInt(35)];
      this.creatureBehaviorResponse1 = getValue1;
      this.creatureBehaviorResponse2 = getValue2;
      this.creatureBehaviorResponse3 = getValue3;
    },
    // weather
    randomizeWeather: function (id) {
      let w = this.getRandomInt(32);
      let wr = '';
      switch (w) {
        case 0:
          wr = "Hail: -1 to MIG DMG";
          break;
        case 1:
          wr = "Volcano: -1 to AC";
          break;
        case 2:
          wr = "Gale Winds: -1 to WIS DMG";
          break;
        case 3:
          wr = "Heavy Fog: -1 to AGI DMG";
          break;
        case 4:
          wr = "Earthquake: DIS to MIG ATK";
          break;
        case 5:
          wr = "Blizzard: -1 to MOVE";
          break;
        case 6:
          wr = "Torrential Rain: DIS to WIS ATK";
          break;
        case 7:
          wr = "Lightning: DMG -1";
          break;
        case 8:
          wr = "Sunny: DMG +1";
          break;
        case 9:
          wr = "Sunny, Calm: ADV on all ATK";
          break;
        case 10:
          wr = "Avalanche: MOVE -2";
          break;
        case 11:
          wr = "Sandstorm: DIS to AGI ATK";
          break;
        case 12:
          wr = "Light Fog: Every Action Roll is -1 unless it is a 10";
          break;
        case 13:
        case 14:
          wr = "Flurries";
          break;
        case 15:
        case 16:
          wr = "Humid";
          break;
        case 17:
        case 18:
          wr = "Rain";
          break;
        case 19:
        case 20:
          wr = "Drizzle";
          break;
        case 21:
        case 22:
          wr = "Breezy";
          break;
        case 23:
        case 24:
          wr = "Cloudy";
          break;
        case 25:
        case 26:
          wr = "Snow";
          break;
        case 27:
        case 28:
          wr = "Cold";
          break;
        case 29:
        case 30:
          wr = "Hot";
          break;
        case 31:
        case 32:  
          wr = "Stormy";
          break;
      }
      this.weatherResponse = wr;
    },
    randomizeEnvironment: function() {
      var array = [
              "Glowing ravine", "Winding brook", "Circle of ruins", "Guard tower",
              "Above a cliff", "Rolling hills", "Deep basin", "Terraced farmland",
              "Tombs", "Hive", "Coven meeting grounds", "Abandoned farmhouse",
              "Decrepit bridge", "Pier with abandoned boats", "Row of pines",
              "Natural bridge", "Dunes", "Large cave opening", "Lava flow", "Mill",
              "Small ponds", "Terraced hillside", "Swamplands", "Steep mountainside",
              "Citadel", "Rushing river", "Trenches", "Sacred well",
              "Spider webs", "Massive statues", "Orchard", "Damp jungle", "Ship graveyard",
              "Dead forest", "Vine-covered cliff", "Canyon", "Boat dock",
              "Below a rocky cliff", "Plain, flat surface", "Statue garden", "Concentric circles of water",
              "Concentric circles of terracing", "Briar patch", "Rocky outcropping",
              "Crater-filled battlefield", "Crystal forest", "Poison forest",
              "Small tunnel", "Giant chasm", "Outpost", "Recent landslide", "Turrets",
              "Explosives storage", "Natural staircase", "Glacier labyrinth",
              "Vine-covered monolith", "Shallow canals", "Gnarled tree roots",
              "Large waterfalls", "Cemetery", "Monastery", "Large holes in ground",
              "Stone wall", "Poison river", "Glassy lake", "Train yard", "Levitating islands",
              "Trade route", "Giant bones", "Timberyard", "Rock pillars", "Massive trees",
              "Narrow glen", "Walled-off garden", "Dam", "Oasis", "Lighthouse",
              "Ravine with rushing water", "Vine curtain forest", "Abandoned shrine",
              "Stone bridge", "Massive waterfall", "Ghost town", "Grove of large oaks",
              "Hedge maze", "Isthmus", "Geyser field", "Old mine", "Patina pool",
              "Fungal forest", "Solid sturdy bridge", "Bouldery hillside", "Stone arches",
              "Overgrown building", "Large estate", "Lagoon", "Flower field", "Leafy bushes",
              "Pyramids", "Quarry", "Obelisks", "Tree village", "Stoney creek", "Windmill",
              "Field", "Meadow", "Boardwalk over a marsh", "Large gate and towers",
              "Several outlooks carved out of stone", "Wooden fortress", "Spike pits",
              "Series of Small tunnels", "Construction site", "Swamp dungeon", "Desert temple",
              "Marble palace", "Prison", "Jail", "Boneyard", "Grotto", "Shipwreck", "Toll", "Mangrove"
                  ];
      // console.log("Encounter: " + (array.length - 1));
      let getValue1 = array[this.getRandomInt(122)];
      let getValue2 = array[this.getRandomInt(122)];
      let getValue3 = array[this.getRandomInt(122)];
      let getValue4 = array[this.getRandomInt(122)];
      // let getValue1 = ;
      // let getValue2 = ;
      // let getValue3 = ;
      // let getValue4 = ;
      let toll1 = this.getRandomInt(5);
      let toll2 = this.getRandomInt(5);
      let toll3 = this.getRandomInt(5);
      let toll4 = this.getRandomInt(5);
      let tollr1 = "";
      let tollr2 = "";
      let tollr3 = "";
      let tollr4 = "";
      do {
        getValue1 = array[this.getRandomInt(122)];
        getValue2 = array[this.getRandomInt(122)];
        getValue3 = array[this.getRandomInt(122)];
        getValue4 = array[this.getRandomInt(122)];
      }
      while (getValue1 === getValue2 || getValue1 === getValue3 || getValue1 === getValue4 || getValue2 === getValue3 || getValue2 === getValue4 || getValue3 === getValue4);
      if (getValue1 == "Toll") {
        switch (toll1) {
          case 0:
          tollr1 = "1g";
          break;
        case 1:
          tollr1 = "5g";
          break;
        case 2:
          tollr1 = "10g";
          break;
        case 3:
          tollr1 = "25g";
          break;
        case 4:
          tollr1 = "50g";
          break;
        case 5:
          tollr1 = "100g";
          break;
        }
      };
      if (getValue2 == "Toll") {
      switch (toll2) {
        case 0:
        tollr2 = "1g";
        break;
      case 1:
        tollr2 = "5g";
        break;
      case 2:
        tollr2 = "10g";
        break;
      case 3:
        tollr2 = "25g";
        break;
      case 4:
        tollr2 = "50g";
        break;
      case 5:
        tollr2 = "100g";
        break;
        }
      };
      if (getValue3 == "Toll") {
        switch (toll3) {
          case 0:
          tollr3 = "1g";
          break;
        case 1:
          tollr3 = "5g";
          break;
        case 2:
          tollr3 = "10g";
          break;
        case 3:
          tollr3 = "25g";
          break;
        case 4:
          tollr3 = "50g";
          break;
        case 5:
          tollr3 = "100g";
          break;
        }
      };
      if (getValue4 == "Toll") {
        switch (toll4) {
          case 0:
          tollr4 = "1g";
          break;
        case 1:
          tollr4 = "5g";
          break;
        case 2:
          tollr4 = "10g";
          break;
        case 3:
          tollr4 = "25g";
          break;
        case 4:
          tollr4 = "50g";
          break;
        case 5:
          tollr4 = "100g";
          break;
        }
      };
      getValue1 = getValue1 + " " + tollr1;
      getValue2 = getValue2 + " " + tollr2;
      getValue3 = getValue3 + " " + tollr3;
      getValue4 = getValue4 + " " + tollr4;
      this.environmentResponse1 = getValue1;
      this.environmentResponse2 = getValue2;
      this.environmentResponse3 = getValue3;
      this.environmentResponse4 = getValue4;
    },
    // loot
    randomizeVis: function() {
      let v = this.getRandomInt(10) + 1;
      if (v < 6) {
        this.loot = "In plain view";
      } else {
        this.loot = "DC " + v + " WIS";
      }
    },
    randomizeWeapon: function () {
      let w = this.getRandomInt(14);
      let wr = "";
      switch (w) {
        case 0:
          wr = "M1 (MIG)";
          break;
        case 1:
          wr = "M2 (MIG)";
          break;
        case 2:
          wr = "M3 (MIG)";
          break;
        case 3:
          wr = "M4 (MIG)";
          break;
        case 4:
          wr = "M5 (MIG)";
          break;
        case 5:
          wr = "A1 (AGI)";
          break;
        case 6:
          wr = "Crossbow (AGI)";
          break;
        case 7:
          wr = "A3 (AGI)";
          break;
        case 8:
          wr = "Longbow (AGI)";
          break;
        case 9:
          wr = "A5 (AGI)";
          break;
        case 10:
          wr = "W1 (WIS)";
          break;
        case 11:
          wr = "W2 (WIS)";
          break;
        case 12:
          wr = "W3 (WIS)";
          break;
        case 13:
          wr = "W4 (WIS)";
          break;
        case 14:
          wr = "W5 (WIS)";
          break;
      }
      this.weaponResponse = wr;
    },
    randomizeLoot: function () {
      let l = this.getRandomInt(100);
      let l2 = this.getRandomInt(200);
      let l3 = this.getRandomInt(14);
      let lr = "";
      let lr2 = "";
      let lr3 = "";

      switch (l) {
        case 0:
          lr = "Agate";
          break;
        case 1:
          lr = "Antler";
          break;
        case 2:
          lr = "Beads";
          break;
        case 3:
          lr = "Books";
          break;
        case 4:
          lr = "Cloth";
          break;
        case 5:
          lr = "Herbs";
          break;
        case 6:
          lr = "Jars";
          break;
        case 7:
          lr = "Spices";
          break;
        case 8:
          lr = "W3";
          break;
        case 9:
          lr = "Gold";
          break;
        case 10:
          lr = "Animal Hide";
          break;
        case 11:
          lr = "Oils";
          break;
        case 12:
          lr = "Incense";
          break;
        case 13:
          lr = "Animal Eye";
          break;
        case 14:
          lr = "Spirits";
          break;
        case 15:
          lr = "Parchment";
          break;
        case 16:
          lr = "Jars";
          break;
        case 17:
          lr = "Vase";
          break;
        case 18:
          lr = "Weapon";
          break;
        case 19:
          lr = "Statue";
          break;
        case 20:
          lr = "Ruby";
          break;
        case 21:
          lr = "Emerald";
          break;
        case 22:
          lr = "Sapphire";
          break;
        case 23:
          lr = "Diamond";
          break;
        case 24:
          lr = "Gold";
          break;
        case 25:
          lr = "Silver";
          break;
        case 26:
          lr = "Globe";
          break;
        case 27:
          lr =  "Spyglass";
          break;
        case 28:
          lr = "Minerals";
          break;
        case 29:
          lr = "Rare Minerals";
          break;
        case 30:
          lr = "Lantern";
          break;
        case 31:
          lr = "Pickled Fruits";
          break;
        case 32:
          lr = "Rare Nuts";
          break;
        case 33:
          lr = "Rare Seeds";
          break;
        case 34:
          lr = "Vials";
          break;
        case 35:
          lr = "Ornate Box";
          break;
        case 36:
          lr = "Crown";
          break;
        case 37:
          lr = "Orb";
          break;
        case 38:
          lr = "Crystals";
          break;
        case 39:
          lr = "Gems";
          break;
        case 40:
          lr = "Leather Straps";
          break;
        case 41:
          lr = "Utensils";
          break;
        case 42:
          lr = "Fossils";
          break;
        case 43:
          lr = "Tomes";
          break;
        case 44:
          lr = "Feathers";
          break;
        case 45:
          lr = "Animal Scales";
          break;
        case 46:
          lr = "Dragon Scales";
          break;
        case 47:
          lr = "Rare Metals";
          break;
        case 48:
          lr = "Rare Wood";
          break;
        case 49:
          lr = "Glass Orb";
          break;
        case 50:
          lr = "Crystal Orb";
          break;
        case 51:
          lr = "Pearls";
          break;
        case 52:
          lr = "Sparkling Gems";
          break;
        case 53:
          lr = "Glowing Gems";
          break;
        case 54:
          lr = "Fancy Cookware";
          break;
        case 55:
          lr = "Rare Oils";
          break;
        case 56:
          lr = "Fishing Lures";
          break;
        case 57:
          lr = "Signet";
          break;
        case 58:
          lr = "Rare Pendant";
          break;
        case 59:
          lr = "Rare Book";
          break;
        case 60:
          lr = "Rare Scroll";
          break;
        case 61:
          lr = "Quartz";
          break;
        case 62:
          lr = "Flute";
          break;
        case 63:
          lr = "Animal Bones";
          break;
        case 64:
          lr = "Rare Feathers";
          break;
        case 65:
          lr = "Glass Figures";
          break;
        case 66:
          lr = "Stone Figures";
          break;
        case 67:
          lr = "Globe";
          break;
        case 68:
          lr = "Trophy";
          break;
        case 69:
          lr = "Medallions";
          break;
        case 70:
          lr = "Coins";
          break;
        case 71:
          lr = "Prisms";
          break;
        case 72:
          lr = "Quill Pen";
          break;
        case 73:
          lr = "Ink";
          break;
        case 74:
          lr = "Wax";
          break;
        case 75:
          lr = "Sparkling Ink";
          break;
        case 76:
          lr = "Fragrant Oils";
          break;
        case 77:
          lr = "Fragrant Herbs";
          break;
        case 78:
          lr = "Animal Skull";
          break;
        case 79:
          lr = "Crystal Skull";
          break;
        case 80:
          lr = "Jewelled Bones";
          break;
        case 81:
          lr = "Jewelry";
          break;
        case 82:
          lr = "Fur";
          break;
        case 83:
          lr = "Rare Flowers";
          break;
        case 84:
          lr = "Magic Weapon";
          break;
        case 85:
          lr = "Rare Metals";
          break;
        case 86:
          lr = "Candles";
          break;
        case 87:
        case 88:
          lr = "Cursed Weapon";
          break;
        case 89:
          lr = "Snow Globe";
          break;
        case 90:
          lr = "Ornament";
          break;
        default:
          lr = "Coins";
      }

      switch (l2) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13:
        case 14:
        case 15:
          lr2 = "1";
          break;
        case 16:
        case 17:
        case 18:
        case 19:
        case 20:
        case 21:
        case 22:
        case 23:
        case 24:
        case 25:
          lr2 = "2";
          break;
        case 26:
        case 27:
        case 28:
        case 29:
        case 30:
        case 31:
        case 32:
        case 33:
        case 34:
        case 35:
        case 36:
        case 37:
          lr2 = "3";
          break;
        case 38:
        case 39:
        case 40:
        case 41:
        case 42:
        case 43:
        case 44:
        case 45:
        case 46:
        case 47:
        case 48:
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
        case 58:
          lr2 = "4";
          break;
        case 59:
        case 60:
        case 61:
        case 62:
        case 63:
        case 64:
          lr2 = "6";
          break;
        case 65:
        case 66:
        case 67:
        case 68:
        case 69:
        case 70:
          lr2 = "7";
          break;
        case 71:
        case 72:
        case 73:
        case 74:
        case 75:
        case 76:
          lr2 = "8";
          break;
        case 77:
        case 78:
        case 79:
        case 80:
        case 81:
        case 82:
        case 83:
          lr2 = "9";
          break;
        case 84:
        case 85:
        case 86:
        case 87:
        case 88:
        case 89:
          lr2 = "10";
          break;
        case 90:
        case 91:
        case 92:
          lr2 = "15";
          break;
        case 93:
        case 94:
        case 95:
          lr2 = "20";
          break;
        case 96:
          lr2 = "25";
          break;
        case 97:
          lr2 = "30";
          break;
        case 98:
          lr2 = "35";
          break;
        case 99:
          lr2 = "40";
          break;
        case 100:
          lr2 = "50";
          break;
        case 101:
          lr2 = "100";
          break;
        default:
          lr2 = "5";
      }
      
      if (lr == "Weapon") {
        switch (l3) {
          case 0:
            lr3 = "M1 (MIG)";
            break;
          case 1:
            lr3 = "M2 (MIG)";
            break;
          case 2:
            lr3 = "M3 (MIG)";
            break;
          case 3:
            lr3 = "M4 (MIG)";
            break;
          case 4:
            lr3 = "M5 (MIG)";
            break;
          case 5:
            lr3 = "A1 (AGI)";
            break;
          case 6:
            lr3 = "Crossbow (AGI)";
            break;
          case 7:
            lr3 = "A3 (AGI)";
            break;
          case 8:
            lr3 = "Longbow (AGI)";
            break;
          case 9:
            lr3 = "A5 (AGI)";
            break;
          case 10:
            lr3 = "W1 (WIS)";
            break;
          case 11:
            lr3 = "W2 (WIS)";
            break;
          case 12:
            lr3 = "W3 (WIS)";
            break;
          case 13:
            lr3 = "W4 (WIS)";
            break;
          case 14:
            lr3 = "W5 (WIS)";
            break;
        }
        this.lootResponse = lr3;
      }
      else if (lr == "Cursed Weapon" || lr == "Magic Weapon") {
        switch (l3) {
          case 0:
            lr3 = "M1 (MIG)";
            break;
          case 1:
            lr3 = "M2 (MIG)";
            break;
          case 2:
            lr3 = "M3 (MIG)";
            break;
          case 3:
            lr3 = "M4 (MIG)";
            break;
          case 4:
            lr3 = "M5 (MIG)";
            break;
          case 5:
            lr3 = "A1 (AGI)";
            break;
          case 6:
            lr3 = "Crossbow (AGI)";
            break;
          case 7:
            lr3 = "A3 (AGI)";
            break;
          case 8:
            lr3 = "Longbow (AGI)";
            break;
          case 9:
            lr3 = "A5 (AGI)";
            break;
          case 10:
            lr3 = "W1 (WIS)";
            break;
          case 11:
            lr3 = "W2 (WIS)";
            break;
          case 12:
            lr3 = "W3 (WIS)";
            break;
          case 13:
            lr3 = "W4 (WIS)";
            break;
          case 14:
            lr3 = "W5 (WIS)";
            break;
        }
        this.lootResponse = lr + " - " + lr3;
      }
      else {
        this.lootResponse = lr + " " + lr2 + "g";
      }
      // console.log("Loot1:" + (lr));
    },
    // reset
    resetEncounter: function () {
      this.resetDC();
      this.randomizeNumberOfCreatures();
      this.randomizeBehavior();
      this.randomizeWeather();
      this.randomizeEnvironment();
      this.randomizeLoot();
      this.randomizeWeapon();
      this.randomizeCreatureTypes(nr);
    },
    shakeX() {
      this.disabled = true
      setTimeout(() => {
        this.disabled = false
      }, 1500)
    },
  }
}

</script>
<style lang="scss" scoped>
table {
  table-layout: fixed;
  width: 100%;
}
td {
  font-size: 12px;
  padding: 5px;
  word-wrap: break-word;
}
p {
  margin-bottom: 0px;
}
tr {
  td {
    tr {
      td {
        border-left: none;
        border-right: none;
      }
    }
  }
}
.eTable {
  td {
    padding: 0px;
  }
}
#reset {
  color: black;
  font-weight: bolder;
  width: 30%;
  grid-area: 1 / 1 / 1 / span 3;
}
#damagespan {
  font-weight: bolder;
  border-radius: 15px;
  margin-bottom: 10px;
  color: black;
  padding: 15px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  width: 60%;
  margin-left: 10%;
  grid-area: 1 / 2 / span 1 / span 3; 
}
::-webkit-scrollbar-thumb {
  width: 10px;
}
.ebut {
  margin-right: 20px;
}
.fill {
  background-color: #2d2653;
  color: rgb(255, 255, 255);
  font-weight: bold;
}
td {
  border: 1px solid #2d2653;
}
.fixed {
  width: 60px;
  max-width: 60px;
  height: 120px;
  max-height: 120px;
}
.encounter {
  width: 150px;
  max-width: 150px;
}
.shakeX {
  animation: shakeX 0.82s cubic-bezier(.36,.07,.19,.97) both;
  transform: translate3d(0, 0, 0);
}
.fixedwidth2 {
  width:25px;
  min-width: 25px;
}
.input_hp {
  background-color: #080808;
  border: none;
  color: white;
  width: 100%;
  font-size: 10pt;
}
.spacing {
  margin-bottom: 10px;
}
.inputEnemy {
  border: none;
  width: 200%;
}
::placeholder {
    color:white;
    opacity: 1;
  }
::-ms-input-placeholder {
  color:black;
}
@keyframes shakeX {
  10%, 90% {
    transform: translate3d(-5px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(5px, 0px, 0px);
  }
  30%, 50%, 70% {
    transform: translate3d(-5px, 0px, 0);
  }
  40%, 60% {
    transform: translate3d(10px, 0px, 0);
  }
}
// 
</style>